// Multi-language translations for Planet Group Baku (EN / AZ / RU)
export const translations = {
  en: {
    nav: {
      home: "Home",
      ikel: "İKEL MT",
      furniture: "Furniture",
      logistics: "Logistics",
      quote: "Get a Quote",
    },
    common: {
      requestQuote: "Request a Quote",
      learnMore: "Learn More",
      viewDetails: "View Details",
      chatWhatsapp: "Chat on WhatsApp",
      ourDivisions: "Our Divisions",
      getInTouch: "Get in touch",
      backHome: "Back to Home",
      submit: "Submit Request",
      submitting: "Submitting...",
      successTitle: "Thank you.",
      successMsg: "Your request has been received. Our team will contact you within 24 hours.",
      errorMsg: "Something went wrong. Please try again.",
      readyCatalogue: "Ready catalogue · In-stock products imported from China to Azerbaijan. Custom sourcing also welcome.",
      readyBadge: "Ready catalogue available",
      visitStore: "Visit Our Store",
      followUs: "Follow us",
      chat: {
        title: "Ask Planet Group Baku",
        subtitle: "Hardware · Furniture · Logistics",
        placeholder: "Ask about products, prices or shipping...",
        send: "Send",
        welcome: "Hi! I'm the Planet Group Baku assistant. Ask me about furniture hardware, tables & chairs or shipping from China to Baku. How can I help?",
        typing: "Assistant is typing...",
        openAria: "Open chat",
        closeAria: "Close chat",
        errorReply: "Sorry, I couldn't reach the assistant right now. Please try again or WhatsApp +994 51 516 93 01.",
      },
      catalogueSearch: {
        placeholder: "Search catalogue (e.g. hinge, slide, leg)",
        results: "results",
        noResults: "No matches. Try another keyword.",
        clear: "Clear",
      },
      shipments: {
        eyebrow: "Live From China",
        title: "Recent shipments from our factories.",
        subtitle: "A rolling snapshot of containers and pallets currently moving from Foshan & Guangzhou to Baku.",
        status: {
          loaded: "Loaded",
          inTransit: "In transit",
          arrived: "Arrived Baku",
          customs: "Customs",
        },
      },
      gallery: {
        eyebrow: "Operations · On The Ground",
        title: "Real photos from our warehouse, factories and containers.",
        subtitle: "We're not a reseller — we're on the ground in Foshan, Shunde and Baku. Here's the proof.",
        tagStock: "In stock · İKEL MT",
        tagWarehouse: "Warehouse · Baku",
        tagFactory: "Factory · Foshan",
        tagContainer: "Loading · Guangzhou",
        placeholder: "Your photo here",
      },
      leadMagnet: {
        heading: "Download the İKEL MT 2026 catalogue",
        subtitle: "137 pages of hinges, slides, mechanisms, fittings and legs — direct factory prices. Enter your email and WhatsApp and we'll send it over instantly.",
        emailLabel: "Email",
        whatsappLabel: "WhatsApp number",
        whatsappPlaceholder: "+994 …",
        submit: "Send me the catalogue",
        sending: "Sending...",
        success: "Thanks! The catalogue is downloading now.",
        skip: "No thanks, just download",
        privacy: "We'll only contact you about price lists and new stock. No spam.",
      },
      guibang: {
        eyebrow: "Official Distributor",
        title: "Proud official distributor of Guibang in Azerbaijan.",
        subtitle: "Guibang is one of China's leading furniture hardware manufacturers — hinges, slides, fittings trusted by top factories. As their official partner we bring the full Guibang range to Baku at direct-factory pricing, sold through the İKEL MT brand.",
        catalogueTitle: "Guibang 2026 Catalogue",
        catalogueDesc: "58 pages of premium hardware — browse online or request the full range.",
        browse: "Browse Guibang catalogue",
        badge: "Authorised · Official distributor",
        partner: "Brand partner",
      },
      catalogue: {
        eyebrow: "Full Product Catalogue",
        title: "137 pages · Hinges, slides, mechanisms, fittings, legs.",
        subtitle: "Browse every product available for import from our China network. Ready in our Baku warehouse or custom sourced on request.",
        featuredLabel: "Catalogue Preview",
        browseAll: "Browse all 137 pages",
        download: "Download PDF",
        close: "Close",
        page: "Page",
        of: "of",
        prev: "Previous",
        next: "Next",
      },
      journey: {
        eyebrow: "The Sourcing Journey",
        title: "From factory floor to your front door.",
        subtitle: "Exactly how the process works — four transparent steps so you always know where your order is and what we're doing for you.",
        steps: [
          { title: "Sourcing", desc: "We find the best factory prices across China — not just Foshan and Shunde, but our full nationwide network of vetted suppliers." },
          { title: "QC Inspection", desc: "We visit the factory in person to check the quality of your specific order before it ships. Photo and video reports on request." },
          { title: "Consolidation", desc: "We combine multiple products from different factories into one container so you save on freight and customs." },
          { title: "Delivery", desc: "We handle customs clearance, shipping and last-mile delivery — straight to your door in Baku or anywhere in Azerbaijan." },
        ],
      },
      whoWeAre: {
        eyebrow: "Who We Are",
        headline: "A legacy of excellence.",
        lede: "At Planet Group Baku, we don't just move products; we move industries. With a heritage built over 25 years in the furniture sector and a specialised 5-year focus on high-performance furniture hardware, we have established ourselves as the premier link between global manufacturing power and the Azerbaijani market.",
        ikelLine: "Through our signature brand, İKEL MT, we bring the world's most reliable hardware solutions — from precision hinges to smart lock systems — directly to the hands of those who build.",
        legacyKicker: "25 Years · Furniture",
        legacyHeadline: "The experience of the past.",
        modernKicker: "Today · İKEL MT",
        modernHeadline: "The technology of the future.",
        servicesEyebrow: "What We Do",
        servicesHeadline: "Triple-A Service.",
        servicesLede: "Designed to eliminate the stress of international trade.",
        services: [
          { tag: "Supply",  title: "Supply", desc: "An exclusive range of furniture and hardware products under the İKEL MT brand, ready for the local market." },
          { tag: "Source",  title: "Source", desc: "If it exists in the Chinese manufacturing hub, we can find it. We leverage our deep factory network to source custom products that meet your specific needs." },
          { tag: "Ship",    title: "Ship",   desc: "We handle the complexity of international logistics. From the factory floor in China to your warehouse in Baku — quality control, consolidation, and shipping." },
        ],
        visionEyebrow: "Vision & Mission",
        visionHeadline: "The operating system for Azerbaijan's furniture industry.",
        visionLede: "We handle the \"how\" so you can focus on the \"what.\"",
        audiences: [
          { tag: "For Stores",       title: "Furniture stores",      desc: "Your ultimate supply partner. We ensure your showrooms are filled with products offering the best price and best quality in the region." },
          { tag: "For Manufacturers", title: "Masters & manufacturers", desc: "The \"bones\" of your furniture. High-end hardware that guarantees durability for your customers while protecting your margins with factory-direct pricing." },
        ],
        philosophyTag: "Why Planet Group Baku",
        philosophyTitle: "Everything for you.",
        philosophyBody: "Whether you are a retail store owner looking for the next bestseller or a master craftsman needing hardware that won't fail, we provide the transparency and expertise that only 25 years of experience can offer.",
        closingTagline: "Planet Group Baku — Your direct bridge to quality.",
      },
    },
    hero: {
      eyebrow: "China → Azerbaijan  //  Direct Factory Supply",
      title1: "High-Quality Sourcing.",
      title2: "Direct Factory Prices.",
      title3: "",
      subtitle:
        "Based in the heart of China, we provide top-tier furniture hardware and ready furniture with a focus on durability and cost-efficiency. Planet Group Baku handles your logistics from the factory floor to your warehouse.",
      ctaPrimary: "Get Wholesale Pricing",
      ctaSecondary: "Explore Hardware Range",
      shortTagline: "High quality, best prices, direct from China.",
      slides: [
        {
          kicker: "Division 01 · Hardware",
          title: "İKEL MT",
          headline: "High-Performance Hardware at Factory Prices.",
          subtitle: "Hinges, drawer slides, mechanisms and fittings — durability that doesn't cost a premium.",
        },
        {
          kicker: "Division 02 · Furniture",
          title: "Planet Group",
          headline: "Top-Selling Furniture. All Over China.",
          subtitle: "Tables, chairs and ready catalogues sourced from vetted factories nationwide — Foshan, Shunde, Shenzhen, Dongguan, Hangzhou and beyond.",
        },
        {
          kicker: "Division 03 · Logistics",
          title: "Planet Group Baku",
          headline: "Seamless Shipping from China to Your Door.",
          subtitle: "Container consolidation, customs and last-mile — Foshan to Baku in 25–40 days.",
        },
      ],
      slideCta: "Get Wholesale Price",
      slideAriaPrev: "Previous slide",
      slideAriaNext: "Next slide",
    },
    trio: {
      eyebrow: "Three Divisions. One Ecosystem.",
      title: "Engineered for manufacturers, dealers and importers.",
      ikel: {
        tag: "01 / Hardware  ·  5+ years",
        title: "İKEL MT — High-Performance Hardware",
        desc: "Why pay more for the same quality? The perfect balance of long-lasting durability and the best market prices. Hinges, slides and handles built for heavy daily use.",
        cta: "Explore Hardware",
      },
      furniture: {
        tag: "02 / Furniture  ·  20+ years",
        title: "Planet Group — Export Tables & Chairs",
        desc: "Best-selling furniture designs sourced directly from our vetted factory network all over China. We don't stop at Foshan and Shunde — we supply from every major manufacturing hub.",
        cta: "Explore Furniture",
      },
      logistics: {
        tag: "03 / Logistics",
        title: "Planet Group Baku — Sourcing & Logistics",
        desc: "We simplify your China trade. We find the goods, check the quality, and ship them at the lowest freight rates. One invoice from factory to your door.",
        cta: "Explore Logistics",
      },
    },
    stats: {
      eyebrow: "By the Numbers",
      items: [
        { value: "20+", label: "Years in furniture business" },
        { value: "5+", label: "Years in hardware business" },
        { value: "50+", label: "Reliable verified suppliers" },
      ],
    },
    trust: {
      eyebrow: "Why Partner With Us",
      title: "Your direct link to China's best quality and prices.",
      items: [
        { title: "Factory-direct prices", desc: "We're on the ground in China — no middlemen, no markups. You get the factory price, we handle the rest." },
        { title: "Strict quality control", desc: "'Best quality' isn't a slogan — it's our process. We inspect every shipment before it leaves the floor." },
        { title: "Logistics expertise", desc: "We handle the paperwork, containers and customs. End-to-end from factory to your door." },
        { title: "Flexible order sizes", desc: "Full container, partial load or wholesale hardware shipment — we accommodate any business size." },
      ],
    },
    ikelPage: {
      eyebrow: "Furniture Hardware · Azerbaijan",
      title: "İKEL MT — The cheapest prices on the highest quality hinges, slides and mechanisms.",
      subtitle:
        "Hinges, drawer slides, bed-lift mechanisms, flap-door systems, connectors and furniture legs. Direct from our partner factories in China, ready in our Baku warehouse. Where details create distinction.",
      experienceBadge: "Years specialised in furniture hardware",
      catalogTitle: "Product Catalog",
      categories: [
        { name: "Furniture hinges", desc: "Soft-close, two-way, waterproof and self-dumping hinges — rated for 80,000+ cycles. Cheapest direct-import pricing." },
        { name: "Drawer slides", desc: "Three-section, soft-close and bounce-off slide rails up to 60 kg. Silent, durable, in-stock sizes." },
        { name: "Bed-lift mechanisms", desc: "Gas-assisted lifters and linkages for storage beds. Multiple force ratings, ready inventory." },
        { name: "Flap-door systems", desc: "Lift-up, fold and soft-close flap fittings for overhead cabinets and kitchens." },
        { name: "Connectors & fittings", desc: "Cam locks, dowels, shelf supports, glass clamps, railing and sliding-door wheels." },
        { name: "Furniture legs", desc: "Aluminium-alloy and steel legs in black, gold and chrome. Sizes 60–350 mm." },
      ],
      ctaTitle: "Need wholesale pricing?",
      ctaDesc: "Tell us your volume and destination — we'll send a quote within 24 hours.",
      hingeCalc: {
        eyebrow: "Spec Finder · Hinge Load",
        title: "How many hinges does your door need?",
        subtitle: "Enter the door weight and height — we'll recommend the exact hinge count and model for a safe, long-lasting build.",
        fields: {
          weight: "Door Weight (kg)",
          height: "Door Height (mm)",
        },
        resultTitle: "Recommended configuration",
        hinges: "hinges",
        recommendedModel: "Model",
        ctaHelper: "Talk to our hardware expert for bulk pricing on the recommended model.",
        disclaimer: "Guideline based on furniture-industry standards (EN 1935 class 4). For oversized, glass or specialty doors contact us for an engineering review.",
        models: {
          softCloseStandard: {
            name: "İKEL MT Soft-Close Standard · Ø35 mm",
            desc: "Clip-on cup hinge with integrated damper — cabinet-standard for light to medium doors.",
            specs: [
              "Rated for up to 10 kg per hinge",
              "80,000+ cycle tested · EN 1935 class 4",
              "Available in Chrome, Gold and Matte Black",
              "3-way adjustment (height, depth, side)",
            ],
          },
          softCloseHeavy: {
            name: "İKEL MT Heavy-Duty Soft-Close · Ø35 mm HD",
            desc: "Reinforced cup hinge with dual-damper system for wardrobes and tall cabinets.",
            specs: [
              "Rated for up to 25 kg per hinge",
              "Tested over 120,000 closing cycles",
              "Chrome finish · optional Matte Black",
              "Zero-protrusion hinge arm · 110° opening",
            ],
          },
          industrialTwoWay: {
            name: "İKEL MT Industrial Two-Way · Full-Metal",
            desc: "Solid steel industrial hinge for heavy wardrobe and storage doors.",
            specs: [
              "Rated for 25–45 kg per hinge",
              "Full cold-rolled steel body, anti-corrosion plating",
              "180° opening · safety self-closing option",
              "Shipped directly from Foshan partner factory",
            ],
          },
        },
      },
      quickOrder: {
        eyebrow: "Digital Hardware Catalog",
        title: "Quick-order reference. Find it, quote it.",
        subtitle: "A searchable index of our most-ordered İKEL MT items. Filter by finish and mechanism — tap any row to request wholesale pricing.",
        filters: {
          search: "Search",
          searchPlaceholder: "SKU or category…",
          finish: "Finish",
          mech: "Mechanism",
          all: "All",
        },
        headers: {
          sku: "SKU",
          type: "Category",
          mech: "Mechanism",
          finish: "Finish",
          load: "Load",
          action: "Action",
        },
        results: "results",
        noResults: "No products match these filters. Clear them and try again.",
        quoteCta: "Request price",
        types: {
          hinge: "Hinge",
          slide: "Drawer slide",
          bedLift: "Bed-lift",
          flap: "Flap system",
          leg: "Furniture leg",
        },
        mechanisms: {
          softClose: "Soft-close",
          twoWay: "Two-way",
          bounceOff: "Bounce-off",
          gasAssisted: "Gas-assisted",
          fold: "Fold",
          fixed: "Fixed",
        },
        finishes: {
          chrome: "Chrome",
          gold: "Gold",
          matteBlack: "Matte Black",
        },
      },
      store: {
        eyebrow: "Retail Store · Azerbaijan",
        brand: "KEL MEBEL AKSESUARLARI",
        tagline: "Cheapest prices, highest quality — furniture hardware in Azerbaijan.",
        subtitle: "Our Baku retail store carries the ready catalogue imported directly from our China network. Walk in, see the product, take it home the same day. Prefer something custom? We also source on request.",
        stockBadge: "Ready stock in Baku",
        customBadge: "Custom sourcing on request",
        emailLabel: "Hardware store",
        visitCta: "Visit the store",
      },
    },
    furniturePage: {
      eyebrow: "Ready Furniture & Sourcing",
      title: "A nationwide factory network across China.",
      subtitle:
        "Planet Group identifies the best manufacturers for tables and chairs — not just from Foshan and Shunde, but from top factories all over China. We don't just find furniture — we inspect every piece to ensure it meets international export standards before it leaves the factory floor.",
      experienceBadge: "Years of deep expertise in furniture sourcing",
      featuresTitle: "The factory-direct advantage",
      features: [
        { title: "Nationwide China network", desc: "Direct access to 480+ verified factories across all major manufacturing hubs — Foshan, Shunde, Shenzhen, Dongguan, Hangzhou and more." },
        { title: "Quality control", desc: "On-site inspections, material verification and pre-shipment photo reports." },
        { title: "Container optimization", desc: "Mixed loads and smart packing to maximize container efficiency and reduce freight cost." },
        { title: "OEM & private label", desc: "Custom designs, branded packaging and exclusive collections for your market." },
      ],
      categoriesTitle: "Product Categories",
      categories: ["Dining tables", "Dining chairs", "Office chairs", "Lounge & bar", "Outdoor sets", "Custom OEM"],
    },
    logisticsPage: {
      eyebrow: "Logistics & Supply Chain",
      title: "We turn China into your local warehouse.",
      subtitle:
        "Planet Group Baku handles the complexity of international trade. From container consolidation and customs clearance to final-mile delivery.",
      servicesTitle: "Services",
      services: [
        { title: "Container consolidation", desc: "LCL & FCL consolidation from multiple suppliers into a single container." },
        { title: "Customs clearance", desc: "Full documentation, HS code classification and duty calculation." },
        { title: "Multimodal shipping", desc: "Sea and rail freight from China to Baku — fastest and most cost-effective routes for Azerbaijan." },
        { title: "Warehousing", desc: "Short and long-term storage at our Foshan and Baku facilities." },
        { title: "Final-mile delivery", desc: "Last-mile distribution to your showroom, warehouse or retail location." },
        { title: "Insurance & tracking", desc: "End-to-end cargo insurance with real-time shipment visibility." },
      ],
      routesTitle: "Trade Routes",
      routes: [
        { from: "Foshan / Guangzhou", to: "Baku, Azerbaijan", mode: "Sea freight", days: "30–40 days" },
        { from: "Foshan / Guangzhou", to: "Baku, Azerbaijan", mode: "Rail freight", days: "25 days" },
      ],
      calculator: {
        eyebrow: "Cost Calculator",
        title: "Get an instant freight estimate.",
        subtitle: "Pick the departure port, container type and cargo weight — we'll return the cheapest available line and show you the total with your service margin already applied.",
        fields: {
          port: "Departure Port",
          type: "Container Type",
          weight: "Cargo Weight (Tons)",
          margin: "Service Margin",
        },
        recommended: "Best Quote",
        line: "Line",
        onwardBaku: "onward to Baku",
        totalLabel: "Estimated Total (CIF)",
        weightSurcharge: "Includes heavy-cargo surcharge of {amount} (margin applied).",
        otherQuotes: "Other quotes",
        noResult: "No route available for this combination.",
        disclaimer: "Indicative only. Final rates depend on departure date, cargo type and current fuel/handling fees. Contact us for a binding offer.",
      },
    },
    quotePage: {
      eyebrow: "Request a Quote",
      title: "Let's build something together.",
      subtitle:
        "Tell us about your project. We'll get back to you within 24 hours with a tailored proposal.",
      form: {
        company: "Company Name",
        contact: "Contact Name",
        email: "Email",
        phone: "Phone",
        product: "Product Interest",
        products: {
          hardware: "Furniture Hardware (İKEL MT)",
          furniture: "Ready Furniture (Tables & Chairs)",
          logistics: "Logistics & Shipping",
          all: "All services",
        },
        destination: "Destination Country",
        targetBudget: "Target Price / Budget",
        targetBudgetPlaceholder: "e.g. $5,000 / 1 container",
        message: "Tell us about your project (optional)",
      },
    },
    footer: {
      tagline: {
        en: "Planet Group Baku – Your direct link to China's best quality and prices.",
        az: "Planet Group Baku – Çinin ən yaxşı keyfiyyət və qiymətinə birbaşa bağlantınız.",
        ru: "Planet Group Baku – Ваша прямая связь с лучшим качеством и ценами Китая.",
      },
      address: "Foshan / Guangzhou, China  ·  Baku, Azerbaijan",
      rights: "All rights reserved.",
      divisions: "Divisions",
      company: "Company",
      contact: "Contact",
      emailLabel: "Email",
      emailIkelLabel: "Hardware (İKEL MT)",
      phoneLabel: "Phone / WhatsApp",
      email: "planetgroupbaku@gmail.com",
      emailIkel: "kelmtfurniturehardware@gmail.com",
      phone: "+994 51 516 93 01",
      social: {
        title: "Follow us",
        instagram: "https://instagram.com/kel.mebel.aksesuarlari",
        instagramHandle: "@kel.mebel.aksesuarlari",
        tiktok: "https://tiktok.com/@kelmebelaksesuarlari",
        tiktokHandle: "@kelmebelaksesuarlari",
        linkedin: "https://linkedin.com/company/planet-group-baku",
        linkedinHandle: "Planet Group Baku",
      },
    },
  },

  az: {
    nav: {
      home: "Ana səhifə",
      ikel: "İKEL MT",
      furniture: "Mebel",
      logistics: "Logistika",
      quote: "Qiymət istəyi",
    },
    common: {
      requestQuote: "Qiymət istəyi",
      learnMore: "Ətraflı",
      viewDetails: "Baxmaq",
      chatWhatsapp: "WhatsApp-da yazın",
      ourDivisions: "Bölmələrimiz",
      getInTouch: "Bizimlə əlaqə",
      backHome: "Ana səhifəyə qayıt",
      submit: "Göndər",
      submitting: "Göndərilir...",
      successTitle: "Təşəkkür edirik.",
      successMsg: "Sorğunuz qəbul edildi. Komandamız 24 saat ərzində sizinlə əlaqə saxlayacaq.",
      errorMsg: "Xəta baş verdi. Zəhmət olmasa bir daha yoxlayın.",
      readyCatalogue: "Hazır kataloq · Çindən Azərbaycana idxal olunmuş anbar məhsulları. Xüsusi sifariş də mümkündür.",
      readyBadge: "Hazır kataloq mövcuddur",
      visitStore: "Mağazamıza gəlin",
      followUs: "Bizi izləyin",
      chat: {
        title: "Planet Group Baku-ya sual ver",
        subtitle: "Aksesuar · Mebel · Logistika",
        placeholder: "Məhsul, qiymət və ya daşıma barədə soruş...",
        send: "Göndər",
        welcome: "Salam! Mən Planet Group Baku-nun köməkçisiyəm. Mebel aksesuarları, masa və stullar və ya Çindən Bakıya daşıma barədə soruşun. Necə kömək edim?",
        typing: "Köməkçi yazır...",
        openAria: "Söhbəti aç",
        closeAria: "Söhbəti bağla",
        errorReply: "Bağışlayın, indi köməkçiyə çata bilmirəm. Bir az sonra yenidən cəhd edin və ya WhatsApp +994 51 516 93 01.",
      },
      catalogueSearch: {
        placeholder: "Kataloqda axtar (məs. menteşə, siyirmə, ayaq)",
        results: "nəticə",
        noResults: "Uyğunluq yoxdur. Başqa söz sınayın.",
        clear: "Təmizlə",
      },
      shipments: {
        eyebrow: "Çindən Canlı",
        title: "Fabriklərimizdən son göndərişlər.",
        subtitle: "Foshan və Quançjoudan Bakıya hazırda yolda olan konteynerlər və paletlərin canlı görüntüsü.",
        status: {
          loaded: "Yükləndi",
          inTransit: "Yoldadır",
          arrived: "Bakıya çatdı",
          customs: "Gömrükdə",
        },
      },
      gallery: {
        eyebrow: "Əməliyyatlar · Sahədə",
        title: "Anbarımız, fabriklərimiz və konteynerlərdən əsl foto.",
        subtitle: "Biz distribyutor deyilik — Foshan, Shunde və Bakıda sahədəyik. Budur sübut.",
        tagStock: "Anbarda · İKEL MT",
        tagWarehouse: "Anbar · Bakı",
        tagFactory: "Fabrik · Foshan",
        tagContainer: "Yüklənmə · Quançjou",
        placeholder: "Şəklinizi əlavə edin",
      },
      leadMagnet: {
        heading: "İKEL MT 2026 kataloqunu yükləyin",
        subtitle: "137 səhifə menteşələr, siyirmələr, mexanizmlər, fittinqlər və ayaqlar — fabrikdən birbaşa qiymətlər. E-poçt və WhatsApp yazın — kataloqu dərhal göndərəcəyik.",
        emailLabel: "E-poçt",
        whatsappLabel: "WhatsApp nömrəsi",
        whatsappPlaceholder: "+994 …",
        submit: "Kataloqu göndər",
        sending: "Göndərilir...",
        success: "Təşəkkürlər! Kataloq indi yüklənir.",
        skip: "Xeyr, birbaşa yüklə",
        privacy: "Sizə yalnız qiymət siyahısı və yeni anbar barədə yazacağıq. Spam yoxdur.",
      },
      guibang: {
        eyebrow: "Rəsmi Distribyutor",
        title: "Azərbaycanda Guibang brendinin rəsmi distribyutoruyuq.",
        subtitle: "Guibang Çinin aparıcı mebel aksesuar istehsalçılarından biridir — menteşələr, siyirmələr, fittinqlər. Rəsmi partnyor kimi bütün Guibang çeşidini İKEL MT brendi altında Bakıya fabrikdən birbaşa qiymətlə gətiririk.",
        catalogueTitle: "Guibang 2026 Kataloqu",
        catalogueDesc: "58 səhifə premium aksesuar — onlayn baxın və ya tam çeşidi soruşun.",
        browse: "Guibang kataloquna bax",
        badge: "Təsdiqlənmiş · Rəsmi distribyutor",
        partner: "Brend partnyoru",
      },
      catalogue: {
        eyebrow: "Tam Məhsul Kataloqu",
        title: "137 səhifə · Menteşələr, siyirmələr, mexanizmlər, fittinqlər, ayaqlar.",
        subtitle: "Çin şəbəkəmizdən idxal üçün mövcud olan bütün məhsullara baxın. Bakı anbarımızda hazırdır və ya sifariş əsasında.",
        featuredLabel: "Kataloq Önizləmə",
        browseAll: "137 səhifəyə bax",
        download: "PDF yüklə",
        close: "Bağla",
        page: "Səhifə",
        of: "/",
        prev: "Əvvəlki",
        next: "Növbəti",
      },
      journey: {
        eyebrow: "Təchizat Yolu",
        title: "Fabrikdən qapınıza qədər.",
        subtitle: "Prosesin necə işlədiyini dəqiq göstəririk — dörd şəffaf addım, sifarişinizin harada olduğunu və bizim sizin üçün nə etdiyimizi həmişə bilirsiniz.",
        steps: [
          { title: "Təchizat", desc: "Çin boyunca ən yaxşı fabrik qiymətlərini tapırıq — yalnız Foshan və Shunde deyil, bütün ölkəüzrə təsdiqlənmiş şəbəkəmizdən." },
          { title: "Keyfiyyət yoxlaması", desc: "Göndərişdən əvvəl fabriki şəxsən ziyarət edərək sifarişinizin keyfiyyətini yoxlayırıq. Sorğuya görə foto və video hesabatlar." },
          { title: "Konsolidasiya", desc: "Müxtəlif fabriklərdən bir neçə məhsulu bir konteynerdə birləşdiririk — beləliklə, daşıma və gömrükdən qənaət edirsiniz." },
          { title: "Çatdırılma", desc: "Gömrükləmə, daşıma və son mil çatdırılmanı biz həll edirik — birbaşa Bakıdakı qapınıza və ya Azərbaycanın istənilən nöqtəsinə." },
        ],
      },
      whoWeAre: {
        eyebrow: "Biz kimik?",
        headline: "Mükəmməlliyin mirası.",
        lede: "Planet Group Baku-da biz yalnız məhsul daşımırıq — sənayeləri hərəkətə gətiririk. Mebel sahəsində 25 illik təcrübə və mebel aksesuarlarında 5 illik ixtisaslaşmış fokus ilə qlobal istehsal gücü və Azərbaycan bazarı arasında əsas bağlantıya çevrilmişik.",
        ikelLine: "İmza brendimiz İKEL MT ilə dünyanın ən etibarlı aksesuar həllərini — dəqiq menteşələrdən ağıllı kilid sistemlərinə qədər — birbaşa istehsalçılara çatdırırıq.",
        legacyKicker: "25 İL · MEBEL",
        legacyHeadline: "Keçmişin təcrübəsi.",
        modernKicker: "BU GÜN · İKEL MT",
        modernHeadline: "Gələcəyin texnologiyası.",
        servicesEyebrow: "Nə edirik?",
        servicesHeadline: "Üç-A Xidməti.",
        servicesLede: "Beynəlxalq ticarətin stressini aradan qaldırmaq üçün hazırlanıb.",
        services: [
          { tag: "Təchiz",  title: "Təchiz",  desc: "İKEL MT brendi altında yerli bazar üçün hazır, eksklüziv mebel və aksesuar məhsulları." },
          { tag: "Tap",     title: "Tap",     desc: "Əgər Çin istehsal hubunda varsa — biz tapa bilərik. Xüsusi sifarişlərinizi təmin etmək üçün geniş fabrik şəbəkəmizdən istifadə edirik." },
          { tag: "Daşı",    title: "Daşı",    desc: "Beynəlxalq logistikanın mürəkkəbliyini biz həll edirik. Çindəki fabrikdən Bakıdakı anbarınıza — keyfiyyət nəzarəti, konsolidasiya və daşıma." },
        ],
        visionEyebrow: "Vizyon və Missiya",
        visionHeadline: "Azərbaycan mebel sənayesinin əməliyyat sistemi.",
        visionLede: "\"Necə\" sualını biz həll edirik, siz \"nə\" ilə məşğul olun.",
        audiences: [
          { tag: "Mağazalar üçün",      title: "Mebel mağazaları",         desc: "Sizin əsas təchizat tərəfdaşınız. Salonlarınızın regionun ən yaxşı qiyməti və keyfiyyəti ilə dolu olmasını təmin edirik." },
          { tag: "İstehsalçılar üçün", title: "Ustalar və istehsalçılar", desc: "Mebelinizin \"sümükləri\". Müştərilərinizə davamlılıq təmin edən, fabrikdən birbaşa qiymətlə gəlirinizi qoruyan yüksək səviyyəli aksesuar." },
        ],
        philosophyTag: "Niyə Planet Group Baku",
        philosophyTitle: "Hər şey sizin üçün.",
        philosophyBody: "İstər yeni bestseller axtaran pərakəndə mağaza sahibisiniz, istərsə də sıradan çıxmayan aksesuar axtaran usta — 25 illik təcrübənin təmin edə biləcəyi şəffaflıq və ekspertizanı sizə çatdırırıq.",
        closingTagline: "Planet Group Baku — Keyfiyyətə birbaşa körpünüz.",
      },
    },
    hero: {
      eyebrow: "Çin → Azərbaycan  //  Birbaşa Fabrik Təchizatı",
      title1: "Yüksək Keyfiyyətli Təchizat.",
      title2: "Birbaşa Fabrik Qiymətləri.",
      title3: "",
      subtitle:
        "Çinin mərkəzində yerləşərək, sizə davamlılıq və qənaətə fokuslanan yüksək səviyyəli mebel aksesuarları və hazır mebel təqdim edirik. Planet Group Baku logistikanı fabrik döşəməsindən anbarınıza qədər həll edir.",
      ctaPrimary: "Topdan Qiymət",
      ctaSecondary: "Aksesuar çeşidini kəşf et",
      shortTagline: "Yüksək keyfiyyət, ən sərfəli qiymət, birbaşa Çindən.",
      slides: [
        {
          kicker: "Bölmə 01 · Aksesuar",
          title: "İKEL MT",
          headline: "Fabrik qiymətinə yüksək performanslı aksesuar.",
          subtitle: "Menteşələr, siyirmələr, mexanizmlər və fittinqlər — davamlılıq, premium qiymət olmadan.",
        },
        {
          kicker: "Bölmə 02 · Mebel",
          title: "Planet Group",
          headline: "Ən çox satılan mebel. Bütün Çin boyu.",
          subtitle: "Ölkə üzrə təsdiqlənmiş fabriklərdən masalar, stullar və hazır kataloqlar — Foshan, Shunde, Shenzhen, Dongguan, Hangzhou və daha çoxu.",
        },
        {
          kicker: "Bölmə 03 · Logistika",
          title: "Planet Group Baku",
          headline: "Çindən qapınıza qədər səmərəli daşıma.",
          subtitle: "Konteyner konsolidasiyası, gömrük və son mil — Foshandan Bakıya 25–40 gündə.",
        },
      ],
      slideCta: "Topdan qiymət al",
      slideAriaPrev: "Əvvəlki slayd",
      slideAriaNext: "Növbəti slayd",
    },
    trio: {
      eyebrow: "Üç Bölmə. Bir Ekosistem.",
      title: "İstehsalçılar, dilerlər və idxalatçılar üçün hazırlanıb.",
      ikel: {
        tag: "01 / Aksesuar  ·  5+ il",
        title: "İKEL MT — Yüksək performanslı aksesuar",
        desc: "Niyə eyni keyfiyyətə çox ödəyəsən? Uzunömürlü davamlılıq ilə ən yaxşı bazar qiymətlərinin mükəmməl balansı. Gündəlik ağır istifadə üçün menteşələr, siyirmələr və tutacaqlar.",
        cta: "Aksesuarları kəşf et",
      },
      furniture: {
        tag: "02 / Mebel  ·  20+ il",
        title: "Planet Group — İxrac masaları və stulları",
        desc: "Çinin bütün əsas istehsal mərkəzlərindəki təsdiqlənmiş fabrik şəbəkəmizdən birbaşa ən çox satılan mebel dizaynları. Biz yalnız Foshan və Shunde ilə məhdudlaşmırıq — bütün Çindən təchiz edirik.",
        cta: "Mebeli kəşf et",
      },
      logistics: {
        tag: "03 / Logistika",
        title: "Planet Group Baku — Təchizat və Logistika",
        desc: "Çin ticarətinizi sadələşdiririk. Malları tapırıq, keyfiyyəti yoxlayırıq və ən ucuz tariflərlə göndəririk. Fabrikdən qapınıza — bir hesab-faktura.",
        cta: "Logistikanı kəşf et",
      },
    },
    stats: {
      eyebrow: "Rəqəmlərlə",
      items: [
        { value: "20+", label: "İl mebel biznesində" },
        { value: "5+", label: "İl aksesuar biznesində" },
        { value: "50+", label: "Etibarlı təsdiqlənmiş təchizatçı" },
      ],
    },
    trust: {
      eyebrow: "Niyə bizimlə",
      title: "Çinin ən yaxşı keyfiyyət və qiymətinə birbaşa bağlantınız.",
      items: [
        { title: "Fabrikdən birbaşa qiymət", desc: "Biz Çindəyik — vasitəçi yoxdur, əlavə marja yoxdur. Siz fabrik qiymətini alırsınız, biz qalanını həll edirik." },
        { title: "Ciddi keyfiyyət nəzarəti", desc: "\"Ən yaxşı keyfiyyət\" şüar deyil — bu bizim prosesimizdir. Hər göndəriş fabrikdən çıxmazdan əvvəl yoxlanılır." },
        { title: "Logistika təcrübəsi", desc: "Sənədləri, konteynerləri və gömrüyü biz həll edirik. Fabrikdən qapınıza — baş-başa." },
        { title: "Çevik sifariş həcmləri", desc: "Tam konteyner, qismən yük və ya topdan aksesuar — biznesin hər ölçüsünə uyğunlaşırıq." },
      ],
    },
    ikelPage: {
      eyebrow: "Mebel Aksesuarları · Azərbaycan",
      title: "İKEL MT — Menteşələr, siyirmələr və mexanizmlərdə ən ucuz qiymət və ən yüksək keyfiyyət.",
      subtitle:
        "Menteşələr, siyirmə mexanizmləri, çarpayı qaldırıcıları, açılan qapı sistemləri, birləşdiricilər və ayaqlar. Çindəki partnyor fabriklərimizdən birbaşa, Bakı anbarımızda hazır. Detallar fərqi yaradır.",
      experienceBadge: "İl mebel aksesuarında ixtisaslaşmışıq",
      catalogTitle: "Məhsul Kataloqu",
      categories: [
        { name: "Mebel menteşələri", desc: "Yumşaq bağlanan, ikiistiqamətli, sugeçirməz və özü-açılan menteşələr — 80.000+ dövr. Birbaşa idxal ən ucuz qiymətlər." },
        { name: "Siyirmə mexanizmləri", desc: "60 kq-a qədər üçbölməli, yumşaq bağlanan və açılan siyirmə rayları. Səssiz, davamlı, anbarda." },
        { name: "Çarpayı qaldırıcıları", desc: "Saxlama çarpayıları üçün qazlı qaldırıcılar və birləşdiricilər. Müxtəlif güclər, hazır anbar." },
        { name: "Açılan qapı sistemləri", desc: "Yuxarı şkaflar və mətbəxlər üçün qaldırılan, qatlanan və yumşaq bağlanan açılan qapı sistemləri." },
        { name: "Birləşdiricilər və fittinqlər", desc: "Kam kilidləri, dowellər, rəf dayaqları, şüşə tutucuları, məhəccər və sürüşən qapı təkərləri." },
        { name: "Mebel ayaqları", desc: "Alüminium və polad ayaqlar — qara, qızılı və xrom rənglərdə. Ölçülər 60–350 mm." },
      ],
      ctaTitle: "Topdan qiymət lazımdır?",
      ctaDesc: "Həcminizi və ölkəni bildirin — 24 saat ərzində qiymət göndəririk.",
      hingeCalc: {
        eyebrow: "Spec Finder · Menteşə Yükü",
        title: "Qapınıza neçə menteşə lazımdır?",
        subtitle: "Qapı çəkisini və hündürlüyünü daxil edin — uzunömürlü və təhlükəsiz quraşdırma üçün dəqiq menteşə sayı və modelini tövsiyə edək.",
        fields: {
          weight: "Qapı Çəkisi (kq)",
          height: "Qapı Hündürlüyü (mm)",
        },
        resultTitle: "Tövsiyə olunan konfiqurasiya",
        hinges: "menteşə",
        recommendedModel: "Model",
        ctaHelper: "Tövsiyə olunan modeldə topdan qiymət üçün aksesuar mütəxəssisimizlə əlaqə saxlayın.",
        disclaimer: "Tövsiyə mebel sənayesi standartlarına əsaslanır (EN 1935 sinif 4). Böyük ölçülü, şüşə və ya xüsusi qapılar üçün mühəndis yoxlaması üçün bizimlə əlaqə saxlayın.",
        models: {
          softCloseStandard: {
            name: "İKEL MT Yumşaq Bağlanan Standart · Ø35 mm",
            desc: "Daxili amortizatorlu klipsli kasalı menteşə — yüngül və orta qapılar üçün standart seçim.",
            specs: [
              "Hər menteşə üçün 10 kq-a qədər",
              "80.000+ dövr sınaqdan keçirilib · EN 1935 sinif 4",
              "Xrom, qızıl və mat qara rənglərdə",
              "3 istiqamətdə tənzimlənmə (hündürlük, dərinlik, yan)",
            ],
          },
          softCloseHeavy: {
            name: "İKEL MT Ağır Yük Yumşaq Bağlanan · Ø35 mm HD",
            desc: "İkili amortizator sistemli gücləndirilmiş menteşə — qarderob və hündür şkaflar üçün.",
            specs: [
              "Hər menteşə üçün 25 kq-a qədər",
              "120.000+ bağlanma dövrü sınağı",
              "Xrom · əlavə mat qara",
              "Sıfır çıxıntılı qol · 110° açılma",
            ],
          },
          industrialTwoWay: {
            name: "İKEL MT Sənaye İki Tərəfli · Tam Metal",
            desc: "Ağır qarderob və anbar qapıları üçün tam polad sənaye menteşəsi.",
            specs: [
              "Hər menteşə üçün 25–45 kq",
              "Tam soyuq yuvarlanmış polad korpus, korroziyaya qarşı qaplama",
              "180° açılma · təhlükəsiz özü-bağlanan seçim",
              "Foshan partnyor fabrikindən birbaşa göndərilir",
            ],
          },
        },
      },
      quickOrder: {
        eyebrow: "Rəqəmsal Aksesuar Kataloqu",
        title: "Sürətli sifariş. Tap, qiymət iste.",
        subtitle: "Ən çox sifariş edilən İKEL MT məhsullarının axtarılabilən indeksi. Finiş və mexanizmlə filtrləyin — topdan qiymət istəmək üçün istənilən sətrə toxunun.",
        filters: {
          search: "Axtar",
          searchPlaceholder: "SKU və ya kateqoriya…",
          finish: "Finiş",
          mech: "Mexanizm",
          all: "Hamısı",
        },
        headers: {
          sku: "SKU",
          type: "Kateqoriya",
          mech: "Mexanizm",
          finish: "Finiş",
          load: "Yük",
          action: "Əməliyyat",
        },
        results: "nəticə",
        noResults: "Bu filtrlərə uyğun məhsul yoxdur. Təmizləyib yenidən cəhd edin.",
        quoteCta: "Qiymət iste",
        types: {
          hinge: "Menteşə",
          slide: "Siyirmə rayı",
          bedLift: "Çarpayı qaldırıcısı",
          flap: "Açılan qapı sistemi",
          leg: "Mebel ayağı",
        },
        mechanisms: {
          softClose: "Yumşaq bağlanan",
          twoWay: "İki tərəfli",
          bounceOff: "Açılan",
          gasAssisted: "Qazlı",
          fold: "Qatlanan",
          fixed: "Sabit",
        },
        finishes: {
          chrome: "Xrom",
          gold: "Qızıl",
          matteBlack: "Mat qara",
        },
      },
      store: {
        eyebrow: "Pərakəndə Mağaza · Azərbaycan",
        brand: "KEL MEBEL AKSESUARLARI",
        tagline: "Azərbaycanda ən ucuz qiymət, ən yüksək keyfiyyət — mebel aksesuarları.",
        subtitle: "Bakıdakı mağazamız Çin şəbəkəmizdən birbaşa idxal olunan hazır kataloqu saxlayır. Gəlin, məhsulu görün, həmin gün evə aparın. Xüsusi sifariş istəyirsiniz? Biz onu da tədarük edirik.",
        stockBadge: "Bakıda hazır anbar",
        customBadge: "Xüsusi sifariş mümkündür",
        emailLabel: "Aksesuar mağazası",
        visitCta: "Yol göstər",
        addressLine1: "Binəqədi Şosesi 9",
        addressLine2: "Azpetrolla üz-üzə",
        city: "Bakı, Azərbaycan",
      },
    },
    furniturePage: {
      eyebrow: "Hazır Mebel və Təchizat",
      title: "Çin boyunca ölkə üzrə fabrik şəbəkəsi.",
      subtitle:
        "Planet Group masa və stullar üçün ən yaxşı istehsalçıları tapır — yalnız Foshan və Shunde deyil, bütün Çin boyunca ən yaxşı fabriklərdən. Biz yalnız mebel tapmırıq — beynəlxalq ixrac standartlarına uyğunluğu təmin etmək üçün hər parçanı yoxlayırıq.",
      featuresTitle: "Fabrikdən birbaşa üstünlük",
      features: [
        { title: "Bütün Çin şəbəkəsi", desc: "Bütün əsas istehsal mərkəzlərində 480+ təsdiqlənmiş fabrikə birbaşa çıxış — Foshan, Shunde, Shenzhen, Dongguan, Hangzhou və daha çox." },
        { title: "Keyfiyyət nəzarəti", desc: "Yerində yoxlamalar, material təsdiqi və göndərişdən əvvəl foto hesabatlar." },
        { title: "Konteyner optimizasiyası", desc: "Konteyner səmərəliliyini artırmaq üçün qarışıq yüklər və ağıllı qablaşdırma." },
        { title: "OEM və özəl marka", desc: "Xüsusi dizaynlar, markalı qablaşdırma və bazarınıza xüsusi kolleksiyalar." },
      ],
      categoriesTitle: "Məhsul Kateqoriyaları",
      categories: ["Yemək masaları", "Yemək stulları", "Ofis stulları", "Lounge & bar", "Bağ mebeli", "Xüsusi OEM"],
    },
    logisticsPage: {
      eyebrow: "Logistika və Tədarük Zənciri",
      title: "Çini sizin yerli anbarınıza çeviririk.",
      subtitle:
        "Planet Group Baku beynəlxalq ticarətin mürəkkəbliyini idarə edir. Konteyner konsolidasiyasından gömrükləmə və son mil çatdırılmaya qədər.",
      servicesTitle: "Xidmətlər",
      services: [
        { title: "Konteyner konsolidasiyası", desc: "Bir neçə təchizatçıdan bir konteynerdə LCL və FCL konsolidasiyası." },
        { title: "Gömrükləmə", desc: "Tam sənədləşmə, HS kod təsnifatı və rüsum hesablanması." },
        { title: "Multimodal daşıma", desc: "Çindən Bakıya dəniz və dəmir yolu daşıması — Azərbaycan üçün ən sürətli və qənaətcil marşrutlar." },
        { title: "Anbarlama", desc: "Foshan və Bakı anbarlarımızda qısa və uzunmüddətli saxlama." },
        { title: "Son mil çatdırılma", desc: "Salonunuza, anbarınıza və ya pərakəndə ünvana son mil paylaşdırma." },
        { title: "Sığorta və izləmə", desc: "Real vaxtda görünürlüklə tam yük sığortası." },
      ],
      routesTitle: "Ticarət marşrutları",
      routes: [
        { from: "Foshan / Quançjou", to: "Bakı, Azərbaycan", mode: "Dəniz daşıması", days: "30–40 gün" },
        { from: "Foshan / Quançjou", to: "Bakı, Azərbaycan", mode: "Qatar daşıması", days: "25 gün" },
      ],
      calculator: {
        eyebrow: "Xərc kalkulyatoru",
        title: "Ani daşıma qiyməti alın.",
        subtitle: "Çıxış limanını, konteyner növünü və yük çəkisini seçin — ən ucuz xətti və xidmət marjası əlavə olunmuş yekun qiyməti dərhal göstərək.",
        fields: {
          port: "Çıxış limanı",
          type: "Konteyner növü",
          weight: "Yük çəkisi (Ton)",
          margin: "Xidmət marjası",
        },
        recommended: "Ən yaxşı təklif",
        line: "Xətt",
        onwardBaku: "davamı Bakıya",
        totalLabel: "Təxmini yekun (CIF)",
        weightSurcharge: "Ağır yük əlavəsi {amount} daxildir (marja tətbiq olunub).",
        otherQuotes: "Digər təkliflər",
        noResult: "Bu kombinasiya üçün uyğun marşrut yoxdur.",
        disclaimer: "Yalnız təxmini. Son qiymət çıxış tarixindən, yük növündən və cari yanacaq/yük emalı rüsumlarından asılıdır. Bağlayıcı təklif üçün bizimlə əlaqə saxlayın.",
      },
    },
    quotePage: {
      eyebrow: "Qiymət istəyi",
      title: "Gəlin birlikdə yaradaq.",
      subtitle:
        "Layihəniz haqqında bizə məlumat verin. 24 saat ərzində xüsusi təklif göndərəcəyik.",
      form: {
        company: "Şirkət adı",
        contact: "Əlaqə şəxsi",
        email: "E-poçt",
        phone: "Telefon",
        product: "Məhsul maraqları",
        products: {
          hardware: "Mebel aksesuarları (İKEL MT)",
          furniture: "Hazır mebel (Masa və stullar)",
          logistics: "Logistika və daşıma",
          all: "Bütün xidmətlər",
        },
        destination: "Təyinat ölkəsi",
        targetBudget: "Hədəf qiymət / Büdcə",
        targetBudgetPlaceholder: "məs. $5,000 / 1 konteyner",
        message: "Layihə haqqında (ixtiyari)",
      },
    },
    footer: {
      tagline: {
        en: "Planet Group Baku – Your direct link to China's best quality and prices.",
        az: "Planet Group Baku – Çinin ən yaxşı keyfiyyət və qiymətinə birbaşa bağlantınız.",
        ru: "Planet Group Baku – Ваша прямая связь с лучшим качеством и ценами Китая.",
      },
      address: "Foshan / Quançjou, Çin  ·  Bakı, Azərbaycan",
      rights: "Bütün hüquqlar qorunur.",
      divisions: "Bölmələr",
      company: "Şirkət",
      contact: "Əlaqə",
      emailLabel: "E-poçt",
      emailIkelLabel: "Aksesuar (İKEL MT)",
      phoneLabel: "Telefon / WhatsApp",
      email: "planetgroupbaku@gmail.com",
      emailIkel: "kelmtfurniturehardware@gmail.com",
      phone: "+994 51 516 93 01",
      social: {
        title: "Bizi izləyin",
        instagram: "https://instagram.com/kel.mebel.aksesuarlari",
        instagramHandle: "@kel.mebel.aksesuarlari",
        tiktok: "https://tiktok.com/@kelmebelaksesuarlari",
        tiktokHandle: "@kelmebelaksesuarlari",
        linkedin: "https://linkedin.com/company/planet-group-baku",
        linkedinHandle: "Planet Group Baku",
      },
    },
  },

  ru: {
    nav: {
      home: "Главная",
      ikel: "İKEL MT",
      furniture: "Мебель",
      logistics: "Логистика",
      quote: "Получить расчёт",
    },
    common: {
      requestQuote: "Получить расчёт",
      learnMore: "Подробнее",
      viewDetails: "Смотреть",
      chatWhatsapp: "Написать в WhatsApp",
      ourDivisions: "Наши подразделения",
      getInTouch: "Связаться",
      backHome: "На главную",
      submit: "Отправить",
      submitting: "Отправка...",
      successTitle: "Спасибо.",
      successMsg: "Ваш запрос получен. Мы свяжемся с вами в течение 24 часов.",
      errorMsg: "Что-то пошло не так. Попробуйте ещё раз.",
      readyCatalogue: "Готовый каталог · Товары со склада, импортированные из Китая в Азербайджан. Индивидуальный заказ также возможен.",
      readyBadge: "Готовый каталог в наличии",
      visitStore: "Посетите наш магазин",
      followUs: "Мы в соцсетях",
      chat: {
        title: "Спросите Planet Group Baku",
        subtitle: "Фурнитура · Мебель · Логистика",
        placeholder: "Спросите о товаре, цене или доставке...",
        send: "Отправить",
        welcome: "Здравствуйте! Я ассистент Planet Group Baku. Спросите меня о мебельной фурнитуре, столах и стульях или доставке из Китая в Баку. Чем могу помочь?",
        typing: "Ассистент печатает...",
        openAria: "Открыть чат",
        closeAria: "Закрыть чат",
        errorReply: "Извините, сейчас не могу связаться с ассистентом. Попробуйте позже или WhatsApp +994 51 516 93 01.",
      },
      catalogueSearch: {
        placeholder: "Поиск по каталогу (напр. петля, направляющая, ножка)",
        results: "результатов",
        noResults: "Совпадений нет. Попробуйте другое слово.",
        clear: "Очистить",
      },
      shipments: {
        eyebrow: "Вживую из Китая",
        title: "Последние отгрузки с наших фабрик.",
        subtitle: "Актуальная сводка контейнеров и паллет, идущих прямо сейчас из Фошаня и Гуанчжоу в Баку.",
        status: {
          loaded: "Загружено",
          inTransit: "В пути",
          arrived: "Прибыло в Баку",
          customs: "Таможня",
        },
      },
      gallery: {
        eyebrow: "Работа · На местах",
        title: "Реальные фото со склада, фабрик и контейнеров.",
        subtitle: "Мы не посредники — мы работаем на местах в Фошане, Шунде и Баку. Вот доказательства.",
        tagStock: "В наличии · İKEL MT",
        tagWarehouse: "Склад · Баку",
        tagFactory: "Фабрика · Фошань",
        tagContainer: "Погрузка · Гуанчжоу",
        placeholder: "Добавьте ваше фото",
      },
      leadMagnet: {
        heading: "Скачайте каталог İKEL MT 2026",
        subtitle: "137 страниц: петли, направляющие, механизмы, фурнитура и ножки — цены напрямую с фабрик. Оставьте email и WhatsApp — пришлём каталог мгновенно.",
        emailLabel: "Email",
        whatsappLabel: "Номер WhatsApp",
        whatsappPlaceholder: "+994 …",
        submit: "Прислать каталог",
        sending: "Отправка...",
        success: "Спасибо! Каталог уже скачивается.",
        skip: "Нет, просто скачать",
        privacy: "Будем писать только о прайс-листах и новых поступлениях. Без спама.",
      },
      guibang: {
        eyebrow: "Официальный дистрибьютор",
        title: "Мы — официальный дистрибьютор Guibang в Азербайджане.",
        subtitle: "Guibang — один из ведущих производителей мебельной фурнитуры в Китае: петли, направляющие, фурнитура, которым доверяют лучшие фабрики. Как официальный партнёр мы привозим весь ассортимент Guibang в Баку по заводским ценам — под брендом İKEL MT.",
        catalogueTitle: "Каталог Guibang 2026",
        catalogueDesc: "58 страниц премиальной фурнитуры — смотрите онлайн или запросите весь ассортимент.",
        browse: "Смотреть каталог Guibang",
        badge: "Сертифицирован · Официальный дистрибьютор",
        partner: "Бренд-партнёр",
      },
      catalogue: {
        eyebrow: "Полный каталог продукции",
        title: "137 страниц · Петли, направляющие, механизмы, фурнитура, ножки.",
        subtitle: "Смотрите все товары, доступные к импорту из нашей сети в Китае. В наличии на складе в Баку или под заказ.",
        featuredLabel: "Превью каталога",
        browseAll: "Смотреть все 137 страниц",
        download: "Скачать PDF",
        close: "Закрыть",
        page: "Страница",
        of: "из",
        prev: "Назад",
        next: "Далее",
      },
      journey: {
        eyebrow: "Путь от фабрики к вам",
        title: "От заводского цеха до вашей двери.",
        subtitle: "Как именно работает процесс — четыре прозрачных шага, чтобы вы всегда знали, где ваш заказ и что мы для вас делаем.",
        steps: [
          { title: "Сорсинг", desc: "Находим лучшие заводские цены по всему Китаю — не только в Фошане и Шунде, но и в нашей проверенной сети по всей стране." },
          { title: "Инспекция качества", desc: "Лично выезжаем на фабрику и проверяем качество именно вашего заказа до отгрузки. Фото- и видеоотчёты по запросу." },
          { title: "Консолидация", desc: "Объединяем товары с разных фабрик в один контейнер — экономим ваши деньги на фрахте и таможне." },
          { title: "Доставка", desc: "Берём на себя таможню, перевозку и последнюю милю — прямо до вашей двери в Баку или в любой точке Азербайджана." },
        ],
      },
      whoWeAre: {
        eyebrow: "Кто мы",
        headline: "Наследие совершенства.",
        lede: "В Planet Group Baku мы не просто перемещаем товары — мы двигаем целые отрасли. За плечами 25 лет в мебельной индустрии и 5 лет специализации на высокопроизводительной мебельной фурнитуре. Мы стали главным звеном между мировым производством и рынком Азербайджана.",
        ikelLine: "Под нашим флагманским брендом İKEL MT мы доставляем самые надёжные решения — от точных петель до умных запорных систем — напрямую тем, кто строит.",
        legacyKicker: "25 ЛЕТ · МЕБЕЛЬ",
        legacyHeadline: "Опыт прошлого.",
        modernKicker: "СЕГОДНЯ · İKEL MT",
        modernHeadline: "Технологии будущего.",
        servicesEyebrow: "Что мы делаем",
        servicesHeadline: "Тройной сервис «A».",
        servicesLede: "Создан, чтобы снять с вас весь стресс международной торговли.",
        services: [
          { tag: "Поставка",    title: "Supply",  desc: "Эксклюзивная линейка мебельных и фурнитурных товаров под брендом İKEL MT, готовых к продаже на местном рынке." },
          { tag: "Поиск",       title: "Source",  desc: "Если это существует в китайском промышленном хабе — мы найдём. Используем глубокую сеть фабрик для поиска товаров под ваши задачи." },
          { tag: "Доставка",    title: "Ship",    desc: "Берём на себя всю сложность международной логистики. От фабрики в Китае до вашего склада в Баку — QC, консолидация, отгрузка." },
        ],
        visionEyebrow: "Видение и миссия",
        visionHeadline: "Операционная система мебельной индустрии Азербайджана.",
        visionLede: "Мы решаем «как», чтобы вы могли сосредоточиться на «что».",
        audiences: [
          { tag: "Для магазинов",      title: "Мебельные магазины",      desc: "Ваш главный партнёр по поставкам. Обеспечиваем, чтобы в ваших шоурумах была продукция с лучшей ценой и качеством в регионе." },
          { tag: "Для производителей", title: "Мастера и производители", desc: "«Скелет» вашей мебели. Премиальная фурнитура, гарантирующая долговечность клиентам, при этом защищающая вашу маржу заводскими ценами." },
        ],
        philosophyTag: "Почему Planet Group Baku",
        philosophyTitle: "Всё для вас.",
        philosophyBody: "Владеете ли вы розничным магазином и ищете следующий бестселлер, или вы мастер, которому нужна фурнитура без сбоев — мы даём прозрачность и экспертизу, которые может обеспечить только 25-летний опыт.",
        closingTagline: "Planet Group Baku — Ваш прямой мост к качеству.",
      },
    },
    hero: {
      eyebrow: "Китай → Азербайджан  //  Прямые фабричные поставки",
      title1: "Качественный сорсинг.",
      title2: "Цены напрямую с фабрики.",
      title3: "",
      subtitle:
        "Находясь в самом сердце Китая, мы предоставляем мебельную фурнитуру и готовую мебель высшего уровня с фокусом на долговечность и экономию. Planet Group Baku берёт на себя логистику — от фабрики до вашего склада.",
      ctaPrimary: "Оптовые цены",
      ctaSecondary: "Ассортимент фурнитуры",
      shortTagline: "Высокое качество, лучшая цена, напрямую из Китая.",
      slides: [
        {
          kicker: "Подразделение 01 · Фурнитура",
          title: "İKEL MT",
          headline: "Высокопроизводительная фурнитура по заводским ценам.",
          subtitle: "Петли, направляющие, механизмы и фурнитура — долговечность без переплат.",
        },
        {
          kicker: "Подразделение 02 · Мебель",
          title: "Planet Group",
          headline: "Бестселлеры мебели. Со всего Китая.",
          subtitle: "Столы, стулья и готовый каталог от проверенных фабрик по всему Китаю — Фошань, Шунде, Шэньчжэнь, Дунгуань, Ханчжоу и другие.",
        },
        {
          kicker: "Подразделение 03 · Логистика",
          title: "Planet Group Baku",
          headline: "Бесшовная доставка из Китая до вашей двери.",
          subtitle: "Консолидация, таможня и последняя миля — Фошань → Баку за 25–40 дней.",
        },
      ],
      slideCta: "Узнать оптовую цену",
      slideAriaPrev: "Предыдущий слайд",
      slideAriaNext: "Следующий слайд",
    },
    trio: {
      eyebrow: "Три подразделения. Одна экосистема.",
      title: "Создано для производителей, дилеров и импортёров.",
      ikel: {
        tag: "01 / Фурнитура  ·  5+ лет",
        title: "İKEL MT — Высокопроизводительная фурнитура",
        desc: "Зачем переплачивать за то же качество? Идеальный баланс долговечности и лучшей рыночной цены. Петли, направляющие и ручки для ежедневных тяжёлых нагрузок.",
        cta: "К фурнитуре",
      },
      furniture: {
        tag: "02 / Мебель  ·  20+ лет",
        title: "Planet Group — Экспортные столы и стулья",
        desc: "Бестселлеры напрямую от нашей проверенной сети фабрик по всему Китаю. Мы не ограничиваемся Фошанем и Шунде — мы поставляем из всех ключевых производственных центров.",
        cta: "К мебели",
      },
      logistics: {
        tag: "03 / Логистика",
        title: "Planet Group Baku — Сорсинг и логистика",
        desc: "Мы упрощаем торговлю с Китаем. Находим товар, проверяем качество и отгружаем по самым выгодным тарифам. От фабрики до двери — один счёт.",
        cta: "К логистике",
      },
    },
    stats: {
      eyebrow: "В цифрах",
      items: [
        { value: "20+", label: "Лет в мебельном бизнесе" },
        { value: "5+", label: "Лет в бизнесе фурнитуры" },
        { value: "50+", label: "Проверенных надёжных поставщиков" },
      ],
    },
    trust: {
      eyebrow: "Почему мы",
      title: "Ваша прямая связь с лучшим качеством и ценами Китая.",
      items: [
        { title: "Цены напрямую с фабрики", desc: "Мы на месте в Китае — никаких посредников, никаких наценок. Вы получаете заводскую цену, остальное — на нас." },
        { title: "Строгий контроль качества", desc: "«Лучшее качество» — не слоган, а процесс. Мы инспектируем каждую отгрузку до отправки." },
        { title: "Экспертиза в логистике", desc: "Мы берём на себя документы, контейнеры и таможню. От фабрики до вашей двери — под ключ." },
        { title: "Гибкие объёмы", desc: "Полный контейнер, сборный груз или оптовая партия фурнитуры — подстраиваемся под любой бизнес." },
      ],
    },
    ikelPage: {
      eyebrow: "Мебельная фурнитура · Азербайджан",
      title: "İKEL MT — Самые низкие цены на самые качественные петли, направляющие и механизмы.",
      subtitle:
        "Петли, направляющие, подъёмные механизмы кровати, откидные системы, соединители и ножки. Напрямую от наших фабрик-партнёров в Китае, готовые на складе в Баку. Детали создают отличие.",
      experienceBadge: "Лет специализации в мебельной фурнитуре",
      catalogTitle: "Каталог",
      categories: [
        { name: "Мебельные петли", desc: "Soft-close, двухсторонние, водостойкие и саморазгружающиеся — 80 000+ циклов. Самые низкие цены напрямую." },
        { name: "Направляющие ящиков", desc: "Трёхсекционные, soft-close и выталкивающие направляющие до 60 кг. Тихие, прочные, в наличии." },
        { name: "Подъёмные механизмы кровати", desc: "Газовые подъёмники и соединители для кроватей с хранением. Разные усилия, готовый склад." },
        { name: "Откидные системы", desc: "Подъёмные, складывающиеся и soft-close системы для верхних шкафов и кухонь." },
        { name: "Соединители и фурнитура", desc: "Эксцентрики, шканты, полкодержатели, стеклодержатели, перила и ролики раздвижных дверей." },
        { name: "Ножки для мебели", desc: "Алюминиевые и стальные ножки — чёрный, золото и хром. Размеры 60–350 мм." },
      ],
      ctaTitle: "Нужны оптовые цены?",
      ctaDesc: "Сообщите объём и страну назначения — расчёт в течение 24 часов.",
      hingeCalc: {
        eyebrow: "Spec Finder · Нагрузка на петли",
        title: "Сколько петель нужно вашей двери?",
        subtitle: "Введите вес и высоту двери — мы посчитаем точное количество петель и подберём модель для надёжного долговечного крепления.",
        fields: {
          weight: "Вес двери (кг)",
          height: "Высота двери (мм)",
        },
        resultTitle: "Рекомендованная конфигурация",
        hinges: "петли",
        recommendedModel: "Модель",
        ctaHelper: "Свяжитесь с нашим специалистом, чтобы узнать оптовую цену на рекомендованную модель.",
        disclaimer: "Расчёт основан на мебельных стандартах индустрии (EN 1935 класс 4). Для крупноразмерных, стеклянных или специальных дверей свяжитесь с нами для инженерной оценки.",
        models: {
          softCloseStandard: {
            name: "İKEL MT Soft-Close Standard · Ø35 мм",
            desc: "Накладная чашечная петля с встроенным демпфером — стандарт для шкафов с лёгкими и средними дверями.",
            specs: [
              "До 10 кг на петлю",
              "80 000+ циклов · EN 1935 класс 4",
              "Хром, золото, матовый чёрный",
              "3D-регулировка (высота, глубина, сторона)",
            ],
          },
          softCloseHeavy: {
            name: "İKEL MT Heavy-Duty Soft-Close · Ø35 мм HD",
            desc: "Усиленная чашечная петля с двойным демпфером для шкафов-купе и высоких дверей.",
            specs: [
              "До 25 кг на петлю",
              "Более 120 000 циклов",
              "Хром · опционально матовый чёрный",
              "Плоское плечо · открытие 110°",
            ],
          },
          industrialTwoWay: {
            name: "İKEL MT Industrial Two-Way · Цельнометаллическая",
            desc: "Стальная промышленная петля для тяжёлых шкафных и складских дверей.",
            specs: [
              "25–45 кг на петлю",
              "Цельный корпус из холоднокатаной стали, антикоррозийное покрытие",
              "Открытие 180° · опционально самозакрывание",
              "Отгрузка напрямую с фабрики-партнёра в Фошане",
            ],
          },
        },
      },
      quickOrder: {
        eyebrow: "Цифровой каталог",
        title: "Быстрый заказ. Найди и запроси.",
        subtitle: "Поисковый индекс самых заказываемых позиций İKEL MT. Фильтруйте по покрытию и механизму — нажмите любую строку, чтобы запросить оптовую цену.",
        filters: {
          search: "Поиск",
          searchPlaceholder: "SKU или категория…",
          finish: "Покрытие",
          mech: "Механизм",
          all: "Все",
        },
        headers: {
          sku: "SKU",
          type: "Категория",
          mech: "Механизм",
          finish: "Покрытие",
          load: "Нагрузка",
          action: "Действие",
        },
        results: "результатов",
        noResults: "Нет товаров по этим фильтрам. Сбросьте и попробуйте снова.",
        quoteCta: "Запросить цену",
        types: {
          hinge: "Петля",
          slide: "Направляющая",
          bedLift: "Подъёмник",
          flap: "Откидная система",
          leg: "Ножка",
        },
        mechanisms: {
          softClose: "Soft-close",
          twoWay: "Двухсторонний",
          bounceOff: "С отбросом",
          gasAssisted: "Газовый",
          fold: "Складной",
          fixed: "Жёсткий",
        },
        finishes: {
          chrome: "Хром",
          gold: "Золото",
          matteBlack: "Матовый чёрный",
        },
      },
      store: {
        eyebrow: "Розничный магазин · Азербайджан",
        brand: "KEL MEBEL AKSESUARLARI",
        tagline: "Самые низкие цены и самое высокое качество мебельной фурнитуры в Азербайджане.",
        subtitle: "Наш магазин в Баку держит готовый каталог, импортированный напрямую из нашей сети в Китае. Приходите, смотрите товар и забирайте в тот же день. Нужно что-то под заказ? Мы также работаем индивидуально.",
        stockBadge: "Готовый склад в Баку",
        customBadge: "Индивидуальный заказ",
        emailLabel: "Магазин фурнитуры",
        visitCta: "Как добраться",
        addressLine1: "Binəqədi Şosesi 9",
        addressLine2: "Напротив Азпетрол",
        city: "Баку, Азербайджан",
      },
    },
    furniturePage: {
      eyebrow: "Готовая мебель и сорсинг",
      title: "Общенациональная сеть фабрик по всему Китаю.",
      subtitle:
        "Planet Group находит лучших производителей столов и стульев — не только в Фошане и Шунде, но и на ведущих фабриках по всему Китаю. Мы не просто ищем мебель — мы проверяем каждое изделие на соответствие международным стандартам перед отгрузкой.",
      experienceBadge: "Лет глубокой экспертизы в сорсинге мебели",
      featuresTitle: "Преимущество «напрямую с фабрики»",
      features: [
        { title: "Сеть по всему Китаю", desc: "Прямой доступ к 480+ проверенным фабрикам во всех ключевых производственных центрах — Фошань, Шунде, Шэньчжэнь, Дунгуань, Ханчжоу и не только." },
        { title: "Контроль качества", desc: "Инспекции на месте, проверка материалов и фото-отчёты перед отгрузкой." },
        { title: "Оптимизация контейнеров", desc: "Сборные грузы и умная упаковка для максимальной загрузки." },
        { title: "OEM и собственный бренд", desc: "Кастомные дизайны, брендированная упаковка и эксклюзивные коллекции." },
      ],
      categoriesTitle: "Категории товаров",
      categories: ["Обеденные столы", "Обеденные стулья", "Офисные кресла", "Lounge и бар", "Уличная мебель", "OEM на заказ"],
    },
    logisticsPage: {
      eyebrow: "Логистика и цепочка поставок",
      title: "Превращаем Китай в ваш локальный склад.",
      subtitle:
        "Planet Group Baku берёт на себя сложность международной торговли — от консолидации контейнеров до последней мили.",
      servicesTitle: "Услуги",
      services: [
        { title: "Консолидация контейнеров", desc: "LCL и FCL консолидация от нескольких поставщиков в один контейнер." },
        { title: "Таможенное оформление", desc: "Полный пакет документов, классификация по HS и расчёт пошлин." },
        { title: "Мультимодальная перевозка", desc: "Море и ж/д из Китая в Баку — самые быстрые и выгодные маршруты для Азербайджана." },
        { title: "Складирование", desc: "Кратко- и долгосрочное хранение в Фошане и Баку." },
        { title: "Последняя миля", desc: "Доставка в ваш шоурум, склад или розничную точку." },
        { title: "Страхование и трекинг", desc: "Полное страхование груза и трекинг в реальном времени." },
      ],
      routesTitle: "Торговые маршруты",
      routes: [
        { from: "Фошань / Гуанчжоу", to: "Баку, Азербайджан", mode: "Море", days: "30–40 дней" },
        { from: "Фошань / Гуанчжоу", to: "Баку, Азербайджан", mode: "Ж/д", days: "25 дней" },
      ],
      calculator: {
        eyebrow: "Калькулятор стоимости",
        title: "Мгновенная оценка фрахта.",
        subtitle: "Выберите порт отправления, тип контейнера и вес груза — мы сразу покажем самую выгодную линию и итог с вашей сервисной наценкой.",
        fields: {
          port: "Порт отправления",
          type: "Тип контейнера",
          weight: "Вес груза (тонн)",
          margin: "Сервисная наценка",
        },
        recommended: "Лучшее предложение",
        line: "Линия",
        onwardBaku: "далее до Баку",
        totalLabel: "Итого (CIF)",
        weightSurcharge: "Включена надбавка за тяжёлый груз {amount} (с учётом наценки).",
        otherQuotes: "Другие предложения",
        noResult: "Нет маршрута для этой комбинации.",
        disclaimer: "Только ориентировочно. Финальные ставки зависят от даты отправки, типа груза и актуальных топливных/портовых сборов. Свяжитесь для обязывающего предложения.",
      },
    },
    quotePage: {
      eyebrow: "Запрос расчёта",
      title: "Давайте создадим что-то вместе.",
      subtitle:
        "Расскажите о проекте. Мы вернёмся с предложением в течение 24 часов.",
      form: {
        company: "Название компании",
        contact: "Контактное лицо",
        email: "Email",
        phone: "Телефон",
        product: "Интересующая категория",
        products: {
          hardware: "Мебельная фурнитура (İKEL MT)",
          furniture: "Готовая мебель (столы и стулья)",
          logistics: "Логистика и доставка",
          all: "Все услуги",
        },
        destination: "Страна назначения",
        targetBudget: "Целевая цена / Бюджет",
        targetBudgetPlaceholder: "напр. $5,000 / 1 контейнер",
        message: "Расскажите о проекте (необязательно)",
      },
    },
    footer: {
      tagline: {
        en: "Planet Group Baku – Your direct link to China's best quality and prices.",
        az: "Planet Group Baku – Çinin ən yaxşı keyfiyyət və qiymətinə birbaşa bağlantınız.",
        ru: "Planet Group Baku – Ваша прямая связь с лучшим качеством и ценами Китая.",
      },
      address: "Фошань / Гуанчжоу, Китай  ·  Баку, Азербайджан",
      rights: "Все права защищены.",
      divisions: "Подразделения",
      company: "Компания",
      contact: "Контакты",
      emailLabel: "Email",
      emailIkelLabel: "Фурнитура (İKEL MT)",
      phoneLabel: "Телефон / WhatsApp",
      email: "planetgroupbaku@gmail.com",
      emailIkel: "kelmtfurniturehardware@gmail.com",
      phone: "+994 51 516 93 01",
      social: {
        title: "Мы в соцсетях",
        instagram: "https://instagram.com/kel.mebel.aksesuarlari",
        instagramHandle: "@kel.mebel.aksesuarlari",
        tiktok: "https://tiktok.com/@kelmebelaksesuarlari",
        tiktokHandle: "@kelmebelaksesuarlari",
        linkedin: "https://linkedin.com/company/planet-group-baku",
        linkedinHandle: "Planet Group Baku",
      },
    },
  },

  tr: {
    nav: {
      home: "Ana Sayfa",
      ikel: "İKEL MT",
      furniture: "Mobilya",
      logistics: "Lojistik",
      quote: "Teklif Al",
    },
    common: {
      requestQuote: "Teklif İste",
      learnMore: "Daha Fazla",
      viewDetails: "Detayları Gör",
      chatWhatsapp: "WhatsApp'tan yaz",
      ourDivisions: "Bölümlerimiz",
      getInTouch: "İletişime geç",
      backHome: "Ana sayfaya dön",
      submit: "Gönder",
      submitting: "Gönderiliyor...",
      successTitle: "Teşekkürler.",
      successMsg: "Talebiniz alındı. Ekibimiz 24 saat içinde sizinle iletişime geçecek.",
      errorMsg: "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
      readyCatalogue: "Hazır katalog · Çin'den Azerbaycan'a ithal edilen stok ürünleri. Özel sipariş de mümkündür.",
      readyBadge: "Hazır katalog mevcut",
      visitStore: "Mağazamızı ziyaret edin",
      followUs: "Bizi takip edin",
      chat: {
        title: "Planet Group Baku'ya sor",
        subtitle: "Aksesuar · Mobilya · Lojistik",
        placeholder: "Ürün, fiyat veya kargo hakkında sor...",
        send: "Gönder",
        welcome: "Merhaba! Ben Planet Group Baku asistanıyım. Mobilya aksesuarları, masa ve sandalyeler ya da Çin'den Bakü'ye kargo hakkında sorun. Nasıl yardımcı olabilirim?",
        typing: "Asistan yazıyor...",
        openAria: "Sohbeti aç",
        closeAria: "Sohbeti kapat",
        errorReply: "Üzgünüm, şu an asistana ulaşamıyorum. Lütfen tekrar deneyin ya da WhatsApp +994 51 516 93 01.",
      },
      catalogueSearch: {
        placeholder: "Katalogda ara (ör. menteşe, ray, ayak)",
        results: "sonuç",
        noResults: "Eşleşme yok. Başka bir kelime deneyin.",
        clear: "Temizle",
      },
      shipments: {
        eyebrow: "Çin'den Canlı",
        title: "Fabrikalarımızdan son sevkiyatlar.",
        subtitle: "Foshan ve Guangzhou'dan Bakü'ye yol alan konteynerlerin ve paletlerin anlık özeti.",
        status: {
          loaded: "Yüklendi",
          inTransit: "Yolda",
          arrived: "Bakü'ye ulaştı",
          customs: "Gümrükte",
        },
      },
      gallery: {
        eyebrow: "Operasyon · Sahada",
        title: "Depomuzdan, fabrikalardan ve konteynerlerden gerçek fotoğraflar.",
        subtitle: "Biz aracı değiliz — Foshan, Shunde ve Bakü'de sahadayız. İşte kanıt.",
        tagStock: "Stokta · İKEL MT",
        tagWarehouse: "Depo · Bakü",
        tagFactory: "Fabrika · Foshan",
        tagContainer: "Yükleme · Guangzhou",
        placeholder: "Fotoğrafınız burada",
      },
      leadMagnet: {
        heading: "İKEL MT 2026 kataloğunu indirin",
        subtitle: "137 sayfa menteşe, ray, mekanizma, aksesuar ve ayak — doğrudan fabrika fiyatları. E-posta ve WhatsApp numaranızı yazın, kataloğu anında gönderelim.",
        emailLabel: "E-posta",
        whatsappLabel: "WhatsApp numarası",
        whatsappPlaceholder: "+994 …",
        submit: "Kataloğu gönder",
        sending: "Gönderiliyor...",
        success: "Teşekkürler! Katalog indiriliyor.",
        skip: "Hayır, sadece indir",
        privacy: "Sadece fiyat listesi ve yeni stoklar hakkında yazacağız. Spam yok.",
      },
      guibang: {
        eyebrow: "Resmi Distribütör",
        title: "Azerbaycan'da Guibang markasının resmi distribütörüyüz.",
        subtitle: "Guibang, Çin'in önde gelen mobilya aksesuar üreticilerinden biridir — menteşeler, raylar ve aksesuarlar. Resmi partneri olarak tüm Guibang ürün yelpazesini İKEL MT markası altında doğrudan fabrika fiyatıyla Bakü'ye getiriyoruz.",
        catalogueTitle: "Guibang 2026 Kataloğu",
        catalogueDesc: "58 sayfa üst düzey aksesuar — online göz atın veya tüm seriyi talep edin.",
        browse: "Guibang kataloğuna gözat",
        badge: "Yetkili · Resmi distribütör",
        partner: "Marka partneri",
      },
      catalogue: {
        eyebrow: "Tam Ürün Kataloğu",
        title: "137 sayfa · Menteşe, ray, mekanizma, aksesuar, ayak.",
        subtitle: "Çin ağımızdan ithal edilebilen tüm ürünlere göz atın. Bakü deposunda hazır veya özel sipariş.",
        featuredLabel: "Katalog Önizleme",
        browseAll: "Tüm 137 sayfaya gözat",
        download: "PDF indir",
        close: "Kapat",
        page: "Sayfa",
        of: "/",
        prev: "Önceki",
        next: "Sonraki",
      },
      journey: {
        eyebrow: "Tedarik Yolculuğu",
        title: "Fabrikadan kapınıza kadar.",
        subtitle: "Sürecin tam olarak nasıl işlediği — dört şeffaf adım, siparişinizin nerede olduğunu ve sizin için ne yaptığımızı her zaman bilirsiniz.",
        steps: [
          { title: "Tedarik", desc: "Çin genelinde en iyi fabrika fiyatlarını buluruz — yalnızca Foshan ve Shunde değil, tüm onaylı ulusal ağımızdan." },
          { title: "Kalite Kontrol", desc: "Sevkiyattan önce fabrikaya bizzat giderek siparişinizin kalitesini kontrol ederiz. Talep üzerine fotoğraf ve video raporları." },
          { title: "Konsolidasyon", desc: "Farklı fabrikalardan birden fazla ürünü tek konteynerde birleştirerek navlun ve gümrükten tasarruf sağlarız." },
          { title: "Teslimat", desc: "Gümrükleme, nakliye ve son mil teslimatını biz yönetiriz — doğrudan Bakü'deki kapınıza veya Azerbaycan'ın herhangi bir yerine." },
        ],
      },
      whoWeAre: {
        eyebrow: "Biz Kimiz",
        headline: "Mükemmelliğin mirası.",
        lede: "Planet Group Baku olarak sadece ürün taşımıyoruz — sektörleri hareket ettiriyoruz. 25 yıllık mobilya deneyimi ve 5 yıllık özel mobilya aksesuarı odağı ile küresel üretim gücü ile Azerbaycan pazarı arasındaki birincil köprüyüz.",
        ikelLine: "Markamız İKEL MT ile dünyanın en güvenilir aksesuar çözümlerini — hassas menteşelerden akıllı kilit sistemlerine kadar — doğrudan üreticilere ulaştırıyoruz.",
        legacyKicker: "25 YIL · MOBİLYA",
        legacyHeadline: "Geçmişin deneyimi.",
        modernKicker: "BUGÜN · İKEL MT",
        modernHeadline: "Geleceğin teknolojisi.",
        servicesEyebrow: "Ne Yapıyoruz",
        servicesHeadline: "Üçlü-A Servis.",
        servicesLede: "Uluslararası ticaretin stresini ortadan kaldırmak için tasarlandı.",
        services: [
          { tag: "Tedarik",   title: "Supply", desc: "İKEL MT markası altında yerel pazara hazır, özel mobilya ve aksesuar ürün yelpazesi." },
          { tag: "Kaynak",    title: "Source", desc: "Çin üretim merkezinde varsa, biz buluruz. Derin fabrika ağımızla özel ihtiyaçlarınıza yönelik tedarik yaparız." },
          { tag: "Nakliye",   title: "Ship",   desc: "Uluslararası lojistiğin karmaşıklığını biz yönetiriz. Çin'deki fabrikadan Bakü'deki deponuza — kalite, konsolidasyon, nakliye." },
        ],
        visionEyebrow: "Vizyon ve Misyon",
        visionHeadline: "Azerbaycan mobilya sektörünün işletim sistemi.",
        visionLede: "\"Nasıl\" kısmını biz halledelim, siz \"ne\" kısmına odaklanın.",
        audiences: [
          { tag: "Mağazalar için",     title: "Mobilya mağazaları",         desc: "Nihai tedarik ortağınız. Mağazalarınızın bölgenin en iyi fiyat ve kalitesiyle dolu olmasını sağlarız." },
          { tag: "Üreticiler için",    title: "Ustalar ve üreticiler",      desc: "Mobilyanızın \"iskeleti\". Müşterilerinize dayanıklılık garantisi veren ve marjınızı doğrudan fabrika fiyatlarıyla koruyan üst düzey aksesuar." },
        ],
        philosophyTag: "Neden Planet Group Baku",
        philosophyTitle: "Her şey sizin için.",
        philosophyBody: "İster bir sonraki bestseller'ı arayan bir perakende sahibi olun, ister arızalanmayacak aksesuar ihtiyacı olan bir usta — 25 yıllık deneyimin sağlayabileceği şeffaflık ve uzmanlığı sunuyoruz.",
        closingTagline: "Planet Group Baku — Kaliteye doğrudan köprünüz.",
      },
    },
    hero: {
      eyebrow: "Çin → Azerbaycan  //  Doğrudan Fabrika Tedariki",
      title1: "Yüksek Kaliteli Tedarik.",
      title2: "Doğrudan Fabrika Fiyatları.",
      title3: "",
      subtitle:
        "Çin'in kalbinde konumlanarak, dayanıklılık ve maliyet verimliliğine odaklanan üst düzey mobilya aksesuarları ve hazır mobilya sunuyoruz. Planet Group Baku lojistiği fabrikadan deponuza kadar üstlenir.",
      ctaPrimary: "Toptan Fiyat Al",
      ctaSecondary: "Aksesuar yelpazesini keşfet",
      shortTagline: "Yüksek kalite, en iyi fiyat, doğrudan Çin'den.",
      slides: [
        {
          kicker: "Bölüm 01 · Aksesuar",
          title: "İKEL MT",
          headline: "Fabrika fiyatına yüksek performanslı aksesuar.",
          subtitle: "Menteşeler, çekmece rayları, mekanizmalar ve aksesuarlar — prim ödemeden dayanıklılık.",
        },
        {
          kicker: "Bölüm 02 · Mobilya",
          title: "Planet Group",
          headline: "En çok satan mobilya. Çin'in her yerinden.",
          subtitle: "Onaylı fabrikalardan masalar, sandalyeler ve hazır kataloglar — Foshan, Shunde, Shenzhen, Dongguan, Hangzhou ve daha fazlası.",
        },
        {
          kicker: "Bölüm 03 · Lojistik",
          title: "Planet Group Baku",
          headline: "Çin'den kapınıza kusursuz kargo.",
          subtitle: "Konteyner konsolidasyonu, gümrük ve son mil — Foshan'dan Bakü'ye 25–40 gün.",
        },
      ],
      slideCta: "Toptan fiyat al",
      slideAriaPrev: "Önceki slayt",
      slideAriaNext: "Sonraki slayt",
    },
    trio: {
      eyebrow: "Üç Bölüm. Tek Ekosistem.",
      title: "Üreticiler, bayiler ve ithalatçılar için tasarlandı.",
      ikel: {
        tag: "01 / Aksesuar  ·  5+ yıl",
        title: "İKEL MT — Yüksek performanslı aksesuar",
        desc: "Aynı kalite için neden fazla ödeyelim? Uzun ömürlü dayanıklılık ile en iyi piyasa fiyatının mükemmel dengesi. Günlük ağır kullanım için menteşeler, raylar ve kulplar.",
        cta: "Aksesuarları keşfet",
      },
      furniture: {
        tag: "02 / Mobilya  ·  20+ yıl",
        title: "Planet Group — İhracat masaları ve sandalyeleri",
        desc: "Çin'in her yerinde onaylı fabrika ağımızdan doğrudan en çok satan mobilya tasarımları. Foshan ve Shunde ile sınırlı değiliz — tüm Çin'den tedarik ediyoruz.",
        cta: "Mobilyaları keşfet",
      },
      logistics: {
        tag: "03 / Lojistik",
        title: "Planet Group Baku — Tedarik ve Lojistik",
        desc: "Çin ticaretinizi basitleştiriyoruz. Ürünü buluyor, kaliteyi kontrol ediyor ve en düşük navlunla gönderiyoruz. Fabrikadan kapınıza — tek fatura.",
        cta: "Lojistiği keşfet",
      },
    },
    stats: {
      eyebrow: "Rakamlarla",
      items: [
        { value: "20+", label: "Yıl mobilya sektöründe" },
        { value: "5+", label: "Yıl aksesuar sektöründe" },
        { value: "50+", label: "Güvenilir onaylı tedarikçi" },
      ],
    },
    trust: {
      eyebrow: "Neden Bizimle",
      title: "Çin'in en iyi kalite ve fiyatına doğrudan bağlantınız.",
      items: [
        { title: "Doğrudan fabrika fiyatları", desc: "Çin'deyiz — aracı yok, komisyon yok. Siz fabrika fiyatını alırsınız, gerisini biz hallederiz." },
        { title: "Sıkı kalite kontrol", desc: "'En iyi kalite' slogan değil, sürecimizin ta kendisi. Her sevkiyatı fabrikadan çıkmadan önce denetliyoruz." },
        { title: "Lojistik uzmanlığı", desc: "Belgeler, konteynerler ve gümrük bizde. Fabrikadan kapınıza — baştan sona." },
        { title: "Esnek sipariş boyutları", desc: "Tam konteyner, kısmi yük veya toptan aksesuar — her işletme boyutuna uyum sağlarız." },
      ],
    },
    ikelPage: {
      eyebrow: "Mobilya Aksesuarı · Azerbaycan",
      title: "İKEL MT — En yüksek kalitedeki menteşe, ray ve mekanizmalarda en ucuz fiyat.",
      subtitle:
        "Menteşeler, çekmece rayları, yatak kaldırma mekanizmaları, kapaklı kapı sistemleri, birleştiriciler ve ayaklar. Çin'deki ortak fabrikalarımızdan doğrudan, Bakü deposunda hazır. Detaylar farkı yaratır.",
      experienceBadge: "Yıl mobilya aksesuarı uzmanlığı",
      catalogTitle: "Ürün Kataloğu",
      categories: [
        { name: "Mobilya menteşeleri", desc: "Yumuşak kapanan, çift yönlü, su geçirmez ve kendinden boşaltan menteşeler — 80.000+ döngü. Doğrudan ithalat en ucuz fiyat." },
        { name: "Çekmece rayları", desc: "Üç bölümlü, yumuşak kapanan ve itmeli raylar 60 kg'a kadar. Sessiz, dayanıklı, stokta." },
        { name: "Yatak kaldırma mekanizmaları", desc: "Saklamalı yataklar için gazlı kaldırıcılar ve bağlantılar. Farklı kuvvetler, hazır stok." },
        { name: "Kapaklı kapı sistemleri", desc: "Üst dolaplar ve mutfaklar için kaldırmalı, katlamalı ve yumuşak kapanan kapaklı kapı sistemleri." },
        { name: "Birleştiriciler & aksesuarlar", desc: "Kam kilitleri, dübeller, raf destekleri, cam tutucular, korkuluk ve sürgülü kapı tekerlekleri." },
        { name: "Mobilya ayakları", desc: "Alüminyum ve çelik ayaklar — siyah, altın ve krom. Ölçüler 60–350 mm." },
      ],
      ctaTitle: "Toptan fiyata mı ihtiyacınız var?",
      ctaDesc: "Hacim ve varış ülkesini söyleyin — 24 saat içinde teklif gönderiyoruz.",
      hingeCalc: {
        eyebrow: "Spec Finder · Menteşe Yükü",
        title: "Kapınıza kaç menteşe lazım?",
        subtitle: "Kapı ağırlığını ve yüksekliğini girin — güvenli ve uzun ömürlü kurulum için doğru menteşe sayısını ve modeli önerelim.",
        fields: {
          weight: "Kapı Ağırlığı (kg)",
          height: "Kapı Yüksekliği (mm)",
        },
        resultTitle: "Önerilen konfigürasyon",
        hinges: "menteşe",
        recommendedModel: "Model",
        ctaHelper: "Önerilen modelde toplu fiyat için aksesuar uzmanımızla iletişime geçin.",
        disclaimer: "Mobilya endüstrisi standartlarına (EN 1935 sınıf 4) göre hesaplanır. Büyük, cam veya özel kapılar için mühendislik değerlendirmesi amacıyla bize ulaşın.",
        models: {
          softCloseStandard: {
            name: "İKEL MT Yumuşak Kapanır Standart · Ø35 mm",
            desc: "Entegre damperli clip-on fincanlı menteşe — hafif/orta kapılar için dolap standardı.",
            specs: [
              "Menteşe başına 10 kg'a kadar",
              "80.000+ döngü test edildi · EN 1935 sınıf 4",
              "Krom, altın ve mat siyah",
              "3 yönlü ayar (yükseklik, derinlik, yan)",
            ],
          },
          softCloseHeavy: {
            name: "İKEL MT Ağır Hizmet Yumuşak Kapanır · Ø35 mm HD",
            desc: "Gardırop ve yüksek dolaplar için çift damperli güçlendirilmiş menteşe.",
            specs: [
              "Menteşe başına 25 kg'a kadar",
              "120.000+ kapanma döngüsü",
              "Krom · opsiyonel mat siyah",
              "Sıfır çıkıntılı kol · 110° açılma",
            ],
          },
          industrialTwoWay: {
            name: "İKEL MT Endüstriyel Çift Yönlü · Tam Metal",
            desc: "Ağır gardırop ve depo kapıları için tam çelik endüstriyel menteşe.",
            specs: [
              "Menteşe başına 25–45 kg",
              "Tam soğuk haddelenmiş çelik gövde, paslanmaz kaplama",
              "180° açılma · güvenli kendi kendine kapanma seçeneği",
              "Foshan partner fabrikasından doğrudan",
            ],
          },
        },
      },
      quickOrder: {
        eyebrow: "Dijital Aksesuar Kataloğu",
        title: "Hızlı sipariş. Bul, teklif al.",
        subtitle: "En çok sipariş edilen İKEL MT ürünlerinin aranabilir indeksi. Kaplama ve mekanizma ile filtreleyin — toptan fiyat için herhangi bir satıra dokunun.",
        filters: {
          search: "Ara",
          searchPlaceholder: "SKU veya kategori…",
          finish: "Kaplama",
          mech: "Mekanizma",
          all: "Tümü",
        },
        headers: {
          sku: "SKU",
          type: "Kategori",
          mech: "Mekanizma",
          finish: "Kaplama",
          load: "Yük",
          action: "Eylem",
        },
        results: "sonuç",
        noResults: "Bu filtrelere uygun ürün yok. Temizleyip tekrar deneyin.",
        quoteCta: "Fiyat iste",
        types: {
          hinge: "Menteşe",
          slide: "Ray",
          bedLift: "Yatak kaldırıcı",
          flap: "Kapaklı kapı sistemi",
          leg: "Ayak",
        },
        mechanisms: {
          softClose: "Yumuşak kapanır",
          twoWay: "Çift yönlü",
          bounceOff: "Geri tepmeli",
          gasAssisted: "Gazlı",
          fold: "Katlanır",
          fixed: "Sabit",
        },
        finishes: {
          chrome: "Krom",
          gold: "Altın",
          matteBlack: "Mat siyah",
        },
      },
      store: {
        eyebrow: "Perakende Mağaza · Azerbaycan",
        brand: "KEL MEBEL AKSESUARLARI",
        tagline: "Azerbaycan'da en ucuz fiyat, en yüksek kalite — mobilya aksesuarları.",
        subtitle: "Bakü mağazamız Çin ağımızdan doğrudan ithal edilen hazır kataloğu bulundurur. Gelin, ürünü görün, aynı gün eve götürün. Özel sipariş mi? Biz onu da tedarik ederiz.",
        stockBadge: "Bakü'de hazır stok",
        customBadge: "Talebe göre özel tedarik",
        emailLabel: "Aksesuar mağazası",
        visitCta: "Mağazaya git",
      },
    },
    furniturePage: {
      eyebrow: "Hazır Mobilya ve Tedarik",
      title: "Çin genelinde ulusal bir fabrika ağı.",
      subtitle:
        "Planet Group masa ve sandalyeler için en iyi üreticileri bulur — yalnızca Foshan ve Shunde'de değil, Çin'in her yerindeki en iyi fabrikalarda. Sadece mobilya bulmuyoruz — her parçayı uluslararası ihracat standartlarına uygunluk için fabrikadan çıkmadan önce denetliyoruz.",
      featuresTitle: "Doğrudan fabrika avantajı",
      features: [
        { title: "Çin geneli ağ", desc: "Tüm büyük üretim merkezlerinde 480+ doğrulanmış fabrikaya doğrudan erişim — Foshan, Shunde, Shenzhen, Dongguan, Hangzhou ve daha fazlası." },
        { title: "Kalite kontrol", desc: "Yerinde denetimler, malzeme doğrulama ve sevkiyat öncesi fotoğraf raporları." },
        { title: "Konteyner optimizasyonu", desc: "Karma yükler ve akıllı paketleme ile maksimum konteyner verimliliği." },
        { title: "OEM & özel etiket", desc: "Özel tasarımlar, markalı ambalaj ve pazarınıza özel koleksiyonlar." },
      ],
      categoriesTitle: "Ürün Kategorileri",
      categories: ["Yemek masaları", "Yemek sandalyeleri", "Ofis sandalyeleri", "Lounge & bar", "Dış mekan setleri", "Özel OEM"],
    },
    logisticsPage: {
      eyebrow: "Lojistik ve Tedarik Zinciri",
      title: "Çin'i yerel deponuza dönüştürüyoruz.",
      subtitle:
        "Planet Group Baku, uluslararası ticaretin karmaşıklığını yönetir. Konteyner konsolidasyonundan gümrük işlemlerine ve son mil teslimata kadar.",
      servicesTitle: "Hizmetler",
      services: [
        { title: "Konteyner konsolidasyonu", desc: "Birden fazla tedarikçiden tek konteynerde LCL ve FCL konsolidasyonu." },
        { title: "Gümrük işlemleri", desc: "Tam belgeleme, HS kod sınıflandırması ve gümrük vergisi hesaplaması." },
        { title: "Çok modlu nakliye", desc: "Çin'den Bakü'ye deniz ve demiryolu — Azerbaycan için en hızlı ve en uygun rotalar." },
        { title: "Depolama", desc: "Foshan ve Bakü tesislerinde kısa ve uzun süreli depolama." },
        { title: "Son mil teslimat", desc: "Showroom, depo veya perakende noktanıza son mil dağıtım." },
        { title: "Sigorta & takip", desc: "Gerçek zamanlı görünürlükle baştan sona kargo sigortası." },
      ],
      routesTitle: "Ticaret Rotaları",
      routes: [
        { from: "Foshan / Guangzhou", to: "Bakü, Azerbaycan", mode: "Deniz", days: "30–40 gün" },
        { from: "Foshan / Guangzhou", to: "Bakü, Azerbaycan", mode: "Demiryolu", days: "25 gün" },
      ],
      calculator: {
        eyebrow: "Maliyet Hesaplayıcı",
        title: "Anında navlun tahmini alın.",
        subtitle: "Çıkış limanı, konteyner tipi ve kargo ağırlığını seçin — en ucuz hattı ve hizmet komisyonu uygulanmış toplam tutarı hemen gösterelim.",
        fields: {
          port: "Çıkış Limanı",
          type: "Konteyner Tipi",
          weight: "Kargo Ağırlığı (Ton)",
          margin: "Hizmet Komisyonu",
        },
        recommended: "En İyi Teklif",
        line: "Hat",
        onwardBaku: "devamı Bakü",
        totalLabel: "Tahmini Toplam (CIF)",
        weightSurcharge: "Ağır kargo ek ücreti {amount} dahildir (komisyon uygulandı).",
        otherQuotes: "Diğer teklifler",
        noResult: "Bu kombinasyon için rota yok.",
        disclaimer: "Yalnızca tahmini. Nihai oranlar kalkış tarihi, kargo türü ve mevcut yakıt/elleçleme ücretlerine bağlıdır. Bağlayıcı teklif için bize ulaşın.",
      },
    },
    quotePage: {
      eyebrow: "Teklif İste",
      title: "Hadi birlikte bir şeyler inşa edelim.",
      subtitle:
        "Projeniz hakkında bize bilgi verin. 24 saat içinde özel teklifle dönüş yapacağız.",
      form: {
        company: "Şirket Adı",
        contact: "İletişim Kişisi",
        email: "E-posta",
        phone: "Telefon",
        product: "İlgilendiğiniz Ürün",
        products: {
          hardware: "Mobilya Aksesuarları (İKEL MT)",
          furniture: "Hazır Mobilya (Masa & Sandalye)",
          logistics: "Lojistik & Nakliye",
          all: "Tüm hizmetler",
        },
        destination: "Varış Ülkesi",
        targetBudget: "Hedef Fiyat / Bütçe",
        targetBudgetPlaceholder: "ör. $5,000 / 1 konteyner",
        message: "Projeniz hakkında (isteğe bağlı)",
      },
    },
    footer: {
      tagline: {
        en: "Planet Group Baku – Your direct link to China's best quality and prices.",
        az: "Planet Group Baku – Çinin ən yaxşı keyfiyyət və qiymətinə birbaşa bağlantınız.",
        ru: "Planet Group Baku – Ваша прямая связь с лучшим качеством и ценами Китая.",
      },
      address: "Foshan / Guangzhou, Çin  ·  Bakü, Azerbaycan",
      rights: "Tüm hakları saklıdır.",
      divisions: "Bölümler",
      company: "Şirket",
      contact: "İletişim",
      emailLabel: "E-posta",
      emailIkelLabel: "Aksesuar (İKEL MT)",
      phoneLabel: "Telefon / WhatsApp",
      email: "planetgroupbaku@gmail.com",
      emailIkel: "kelmtfurniturehardware@gmail.com",
      phone: "+994 51 516 93 01",
      social: {
        title: "Bizi takip edin",
        instagram: "https://instagram.com/kel.mebel.aksesuarlari",
        instagramHandle: "@kel.mebel.aksesuarlari",
        tiktok: "https://tiktok.com/@kelmebelaksesuarlari",
        tiktokHandle: "@kelmebelaksesuarlari",
        linkedin: "https://linkedin.com/company/planet-group-baku",
        linkedinHandle: "Planet Group Baku",
      },
    },
  },

  zh: {
    nav: {
      home: "首页",
      ikel: "İKEL MT",
      furniture: "家具",
      logistics: "物流",
      quote: "获取报价",
    },
    common: {
      requestQuote: "索取报价",
      learnMore: "了解更多",
      viewDetails: "查看详情",
      chatWhatsapp: "WhatsApp 咨询",
      ourDivisions: "我们的部门",
      getInTouch: "联系我们",
      backHome: "返回首页",
      submit: "提交",
      submitting: "提交中...",
      successTitle: "感谢您。",
      successMsg: "您的询盘已收到。我们的团队将在 24 小时内与您联系。",
      errorMsg: "出现问题,请重试。",
      readyCatalogue: "现货目录 · 从中国直接进口至阿塞拜疆。也接受定制采购。",
      readyBadge: "现货目录可用",
      visitStore: "参观我们的门店",
      followUs: "关注我们",
      chat: {
        title: "咨询 Planet Group Baku",
        subtitle: "五金 · 家具 · 物流",
        placeholder: "咨询产品、价格或物流...",
        send: "发送",
        welcome: "您好!我是 Planet Group Baku 的助理。可以咨询家具五金、桌椅,或从中国到巴库的物流。我能为您做什么?",
        typing: "助理正在输入...",
        openAria: "打开聊天",
        closeAria: "关闭聊天",
        errorReply: "抱歉,暂时无法连接助理。请稍后再试或联系 WhatsApp +994 51 516 93 01。",
      },
      catalogueSearch: {
        placeholder: "搜索目录(如:铰链、滑轨、脚)",
        results: "个结果",
        noResults: "未找到匹配项。请尝试其他关键词。",
        clear: "清除",
      },
      shipments: {
        eyebrow: "中国直击",
        title: "工厂最新发货动态。",
        subtitle: "正在从佛山和广州发往巴库的集装箱与托盘实时快照。",
        status: {
          loaded: "已装柜",
          inTransit: "运输中",
          arrived: "已到巴库",
          customs: "海关清关",
        },
      },
      gallery: {
        eyebrow: "现场 · 实地运营",
        title: "仓库、工厂与集装箱的真实照片。",
        subtitle: "我们不是中间商 — 我们就在佛山、顺德和巴库的现场。这就是证据。",
        tagStock: "现货 · İKEL MT",
        tagWarehouse: "仓库 · 巴库",
        tagFactory: "工厂 · 佛山",
        tagContainer: "装柜 · 广州",
        placeholder: "在此添加您的照片",
      },
      leadMagnet: {
        heading: "下载 İKEL MT 2026 产品目录",
        subtitle: "137 页铰链、滑轨、机构、配件及家具脚 — 工厂直接价格。留下邮箱和 WhatsApp,我们立即发送。",
        emailLabel: "邮箱",
        whatsappLabel: "WhatsApp 号码",
        whatsappPlaceholder: "+994 …",
        submit: "发送目录给我",
        sending: "发送中...",
        success: "感谢!目录正在下载。",
        skip: "不用,直接下载",
        privacy: "我们只会就价格单和新到货与您联系。无垃圾邮件。",
      },
      guibang: {
        eyebrow: "官方经销商",
        title: "Guibang 在阿塞拜疆的官方经销商。",
        subtitle: "Guibang 是中国领先的家具五金制造商之一 — 铰链、滑轨、配件深受顶级工厂信赖。作为其官方合作伙伴,我们以 İKEL MT 品牌将 Guibang 全系列以工厂直供价格带到巴库。",
        catalogueTitle: "Guibang 2026 目录",
        catalogueDesc: "58 页高端五金 — 在线浏览或索取完整系列。",
        browse: "浏览 Guibang 目录",
        badge: "授权 · 官方经销商",
        partner: "品牌合作伙伴",
      },
      catalogue: {
        eyebrow: "完整产品目录",
        title: "137 页 · 铰链、滑轨、机构、配件、家具脚。",
        subtitle: "浏览我们中国网络可供进口的所有产品。巴库仓库现货或按需采购。",
        featuredLabel: "目录预览",
        browseAll: "浏览全部 137 页",
        download: "下载 PDF",
        close: "关闭",
        page: "第",
        of: "/共",
        prev: "上一页",
        next: "下一页",
      },
      journey: {
        eyebrow: "采购流程",
        title: "从工厂车间直达您的门口。",
        subtitle: "流程如何运作 — 四个透明步骤,您始终知道订单在哪里以及我们正在为您做什么。",
        steps: [
          { title: "采购", desc: "我们在全中国寻找最佳工厂价格 — 不仅限于佛山和顺德,而是覆盖全国的经过验证的供应商网络。" },
          { title: "质量检验", desc: "在发货前亲自到工厂检验您订单的质量。可按需提供照片和视频报告。" },
          { title: "拼柜合并", desc: "将不同工厂的多个产品合并到一个集装箱中,为您节省运费和关税。" },
          { title: "交付", desc: "我们处理清关、运输及最后一公里配送 — 直接送到您在巴库或阿塞拜疆任何地方的门口。" },
        ],
      },
      whoWeAre: {
        eyebrow: "关于我们",
        headline: "卓越的传承。",
        lede: "在 Planet Group Baku,我们不仅搬运产品,更推动整个行业。凭借 25 年的家具行业积淀和 5 年专注于高性能家具五金,我们已成为全球制造力量与阿塞拜疆市场之间的首要桥梁。",
        ikelLine: "通过我们的旗舰品牌 İKEL MT,我们将世界上最可靠的五金解决方案 — 从精密铰链到智能锁系统 — 直接送到生产者手中。",
        legacyKicker: "25 年 · 家具",
        legacyHeadline: "过往的经验。",
        modernKicker: "今日 · İKEL MT",
        modernHeadline: "未来的科技。",
        servicesEyebrow: "我们做什么",
        servicesHeadline: "三 A 级服务。",
        servicesLede: "旨在消除国际贸易带来的所有压力。",
        services: [
          { tag: "Supply", title: "供货", desc: "以 İKEL MT 品牌推出的专属家具与五金产品系列,为本地市场现货供应。" },
          { tag: "Source", title: "寻源", desc: "如果中国制造枢纽能造得出,我们就能找到。依托深厚的工厂网络,按您的需求定制采购。" },
          { tag: "Ship",   title: "运输", desc: "我们处理国际物流的复杂性。从中国工厂到您在巴库的仓库 — 质检、拼柜与运输。" },
        ],
        visionEyebrow: "愿景与使命",
        visionHeadline: "阿塞拜疆家具行业的操作系统。",
        visionLede: "「怎么做」交给我们,您专注「做什么」。",
        audiences: [
          { tag: "面向门店",   title: "家具门店",   desc: "您的终极供应伙伴。确保您的展厅摆满本地区最优价格和最佳品质的产品。" },
          { tag: "面向厂商",   title: "师傅与制造商", desc: "您家具的「骨架」。高端五金为您的客户带来持久耐用,同时以工厂直供价保护您的利润。" },
        ],
        philosophyTag: "为什么选择 Planet Group Baku",
        philosophyTitle: "一切为您。",
        philosophyBody: "无论您是寻找下一款畅销品的零售店主,还是需要永不失效五金的工匠大师 — 我们都带来 25 年经验所能提供的透明度与专业性。",
        closingTagline: "Planet Group Baku — 您通往品质的直接桥梁。",
      },
    },
    hero: {
      eyebrow: "中国 → 阿塞拜疆  //  工厂直供",
      title1: "高品质采购。",
      title2: "工厂直供价格。",
      title3: "",
      subtitle:
        "我们扎根于中国中心,提供注重耐用性与成本效益的顶级家具五金和成品家具。Planet Group Baku 为您处理从工厂车间到您仓库的物流。",
      ctaPrimary: "获取批发价",
      ctaSecondary: "浏览五金系列",
      shortTagline: "高品质、最佳价格,中国直供。",
      slides: [
        {
          kicker: "部门 01 · 五金",
          title: "İKEL MT",
          headline: "工厂价格的高性能五金。",
          subtitle: "铰链、抽屉滑轨、机构和配件 — 耐用而不必付高价。",
        },
        {
          kicker: "部门 02 · 家具",
          title: "Planet Group",
          headline: "畅销家具,来自全中国。",
          subtitle: "来自全国验证工厂的桌椅和现货目录 — 佛山、顺德、深圳、东莞、杭州等地。",
        },
        {
          kicker: "部门 03 · 物流",
          title: "Planet Group Baku",
          headline: "从中国无缝直达您的门口。",
          subtitle: "集装箱拼柜、清关和最后一公里 — 佛山至巴库 25–40 天。",
        },
      ],
      slideCta: "获取批发价",
      slideAriaPrev: "上一张",
      slideAriaNext: "下一张",
    },
    trio: {
      eyebrow: "三大部门,一个生态。",
      title: "为制造商、经销商和进口商量身打造。",
      ikel: {
        tag: "01 / 五金  ·  5+ 年",
        title: "İKEL MT — 高性能五金",
        desc: "为什么要为同样的品质支付更多?耐用性与最佳市场价格的完美平衡。可应对日常重度使用的铰链、滑轨和把手。",
        cta: "浏览五金",
      },
      furniture: {
        tag: "02 / 家具  ·  20+ 年",
        title: "Planet Group — 出口桌椅",
        desc: "直接来自我们遍布全中国的验证工厂网络的畅销家具设计。我们不仅限于佛山和顺德 — 我们从中国所有主要制造中心供货。",
        cta: "浏览家具",
      },
      logistics: {
        tag: "03 / 物流",
        title: "Planet Group Baku — 采购与物流",
        desc: "我们简化您的对华贸易。找货、验货、以最低运费发货。从工厂到门口 — 一张发票。",
        cta: "浏览物流",
      },
    },
    stats: {
      eyebrow: "数据概览",
      items: [
        { value: "20+", label: "年家具行业经验" },
        { value: "5+", label: "年五金行业经验" },
        { value: "50+", label: "可靠的经验证供应商" },
      ],
    },
    trust: {
      eyebrow: "为何选择我们",
      title: "您与中国最佳品质与价格的直接连接。",
      items: [
        { title: "工厂直供价格", desc: "我们就在中国现场 — 没有中间商,没有加价。您拿到工厂价,其余由我们处理。" },
        { title: "严格质量管控", desc: "“最佳品质”不是口号 — 而是我们的流程。每批货在出厂前都会检验。" },
        { title: "物流专业性", desc: "文件、集装箱和海关 — 我们全包。工厂到门口,端到端。" },
        { title: "灵活订单规模", desc: "整柜、拼柜或批发五金 — 适应任何规模的业务。" },
      ],
    },
    ikelPage: {
      eyebrow: "家具五金 · 阿塞拜疆",
      title: "İKEL MT — 顶级品质的铰链、滑轨和机构,价格最低。",
      subtitle:
        "铰链、抽屉滑轨、床用升降机构、翻门系统、连接件和家具脚。从我们在中国的合作工厂直供,巴库仓库备货。细节决定品质。",
      experienceBadge: "年专注于家具五金",
      catalogTitle: "产品目录",
      categories: [
        { name: "家具铰链", desc: "缓冲关、双向、防水和自卸铰链 — 80,000+ 次循环。直接进口最低价。" },
        { name: "抽屉滑轨", desc: "三节、缓冲关和反弹式滑轨,承重达 60 公斤。安静、耐用、现货供应。" },
        { name: "床用升降机构", desc: "用于储物床的气动升降器和连杆。多种力值,现货库存。" },
        { name: "翻门系统", desc: "用于吊柜和厨房的升降、折叠和缓冲翻门配件。" },
        { name: "连接件与配件", desc: "偏心锁、销钉、层板托、玻璃夹、栏杆和推拉门轮。" },
        { name: "家具脚", desc: "铝合金和钢制脚 — 黑色、金色和铬色。尺寸 60–350 毫米。" },
      ],
      ctaTitle: "需要批发价?",
      ctaDesc: "告诉我们数量和目的地 — 24 小时内提供报价。",
      hingeCalc: {
        eyebrow: "规格查询 · 铰链承重",
        title: "您的门需要几个铰链?",
        subtitle: "输入门的重量和高度 — 我们会推荐确切的铰链数量和型号,确保安全耐用。",
        fields: {
          weight: "门重(公斤)",
          height: "门高(毫米)",
        },
        resultTitle: "推荐配置",
        hinges: "个铰链",
        recommendedModel: "型号",
        ctaHelper: "联系我们的五金专家获取推荐型号的批发价。",
        disclaimer: "依据家具行业标准(EN 1935 四级)。超大、玻璃或特殊门请联系我们进行工程评估。",
        models: {
          softCloseStandard: {
            name: "İKEL MT 阻尼标准 · Ø35 毫米",
            desc: "内置阻尼的卡扣式杯状铰链 — 轻中型门的橱柜标配。",
            specs: [
              "每个铰链承重 10 公斤以内",
              "80,000+ 次循环测试 · EN 1935 四级",
              "铬、金、哑黑三色",
              "三向调节(高度、深度、侧向)",
            ],
          },
          softCloseHeavy: {
            name: "İKEL MT 重型阻尼 · Ø35 毫米 HD",
            desc: "双阻尼加强型杯状铰链,适用于衣柜和高柜门。",
            specs: [
              "每个铰链承重 25 公斤以内",
              "120,000+ 次关闭循环",
              "铬色 · 可选哑黑",
              "零凸起铰臂 · 110° 开启",
            ],
          },
          industrialTwoWay: {
            name: "İKEL MT 工业双向 · 全金属",
            desc: "用于重型衣柜和仓储门的全钢工业铰链。",
            specs: [
              "每个铰链承重 25–45 公斤",
              "全冷轧钢机身,防腐镀层",
              "180° 开启 · 可选安全自闭",
              "佛山合作工厂直供",
            ],
          },
        },
      },
      quickOrder: {
        eyebrow: "数字化五金目录",
        title: "快速下单。搜一下,报个价。",
        subtitle: "İKEL MT 最畅销产品的可搜索索引。按表面和机械筛选 — 点击任意行即可获取批发报价。",
        filters: {
          search: "搜索",
          searchPlaceholder: "SKU 或分类…",
          finish: "表面",
          mech: "机械",
          all: "全部",
        },
        headers: {
          sku: "SKU",
          type: "分类",
          mech: "机械",
          finish: "表面",
          load: "承重",
          action: "操作",
        },
        results: "个结果",
        noResults: "没有匹配的产品。请清除筛选并重试。",
        quoteCta: "询价",
        types: {
          hinge: "铰链",
          slide: "滑轨",
          bedLift: "床用升降器",
          flap: "翻门系统",
          leg: "家具脚",
        },
        mechanisms: {
          softClose: "阻尼",
          twoWay: "双向",
          bounceOff: "反弹",
          gasAssisted: "气撑",
          fold: "折叠",
          fixed: "固定",
        },
        finishes: {
          chrome: "铬",
          gold: "金",
          matteBlack: "哑黑",
        },
      },
      store: {
        eyebrow: "零售门店 · 阿塞拜疆",
        brand: "KEL MEBEL AKSESUARLARI",
        tagline: "阿塞拜疆最低价、最高质的家具五金。",
        subtitle: "我们的巴库零售门店销售直接从中国网络进口的现货目录。到店即看即提。需要定制?我们也可按需采购。",
        stockBadge: "巴库现货",
        customBadge: "接受定制采购",
        emailLabel: "五金门店",
        visitCta: "前往门店",
      },
    },
    furniturePage: {
      eyebrow: "成品家具与采购",
      title: "覆盖全中国的工厂网络。",
      subtitle:
        "Planet Group 为桌椅寻找最佳制造商 — 不仅限于佛山和顺德,而是来自全中国的顶级工厂。我们不仅仅寻找家具 — 我们在每件产品出厂前检验其是否符合国际出口标准。",
      featuresTitle: "工厂直供优势",
      features: [
        { title: "全中国网络", desc: "在所有主要制造中心直接对接 480+ 经验证工厂 — 佛山、顺德、深圳、东莞、杭州等。" },
        { title: "质量控制", desc: "现场检验、材质确认和出货前照片报告。" },
        { title: "集装箱优化", desc: "混装和智能装柜,最大化集装箱利用率,降低运费。" },
        { title: "OEM 与贴牌", desc: "定制设计、品牌包装和面向您市场的独家系列。" },
      ],
      categoriesTitle: "产品类别",
      categories: ["餐桌", "餐椅", "办公椅", "休闲与吧台", "户外套装", "定制 OEM"],
    },
    logisticsPage: {
      eyebrow: "物流与供应链",
      title: "我们把中国变成您的本地仓库。",
      subtitle:
        "Planet Group Baku 处理国际贸易的复杂流程。从集装箱拼柜、清关到最后一公里配送。",
      servicesTitle: "服务",
      services: [
        { title: "集装箱拼柜", desc: "多供应商合并至单个集装箱的 LCL 和 FCL 拼柜。" },
        { title: "海关清关", desc: "完整报关文件、HS 编码分类和关税计算。" },
        { title: "多式联运", desc: "中国到巴库的海运和铁路运输 — 最快且最经济的阿塞拜疆航线。" },
        { title: "仓储", desc: "佛山和巴库仓库的短期和长期仓储。" },
        { title: "最后一公里", desc: "送达您的展厅、仓库或零售点。" },
        { title: "保险与追踪", desc: "端到端货物保险,实时货物可视化。" },
      ],
      routesTitle: "贸易航线",
      routes: [
        { from: "佛山 / 广州", to: "巴库,阿塞拜疆", mode: "海运", days: "30–40 天" },
        { from: "佛山 / 广州", to: "巴库,阿塞拜疆", mode: "铁路", days: "25 天" },
      ],
      calculator: {
        eyebrow: "运费计算器",
        title: "即时获取运费估算。",
        subtitle: "选择出发港、集装箱类型和货物重量 — 我们立即显示最低价船公司及包含您服务佣金后的总费用。",
        fields: {
          port: "出发港",
          type: "集装箱类型",
          weight: "货物重量(吨)",
          margin: "服务佣金",
        },
        recommended: "最优报价",
        line: "船公司",
        onwardBaku: "续转巴库",
        totalLabel: "预估总额 (CIF)",
        weightSurcharge: "已含重货附加费 {amount}(已应用佣金)。",
        otherQuotes: "其他报价",
        noResult: "此组合暂无可用航线。",
        disclaimer: "仅供参考。最终费率取决于出发日期、货物类型及当前燃油/操作附加费。如需正式报价请与我们联系。",
      },
    },
    quotePage: {
      eyebrow: "索取报价",
      title: "让我们一起合作。",
      subtitle:
        "告诉我们您的项目。我们将在 24 小时内回复定制方案。",
      form: {
        company: "公司名称",
        contact: "联系人",
        email: "邮箱",
        phone: "电话",
        product: "关注的产品",
        products: {
          hardware: "家具五金 (İKEL MT)",
          furniture: "成品家具(桌椅)",
          logistics: "物流与运输",
          all: "全部服务",
        },
        destination: "目的地国家",
        targetBudget: "目标价格 / 预算",
        targetBudgetPlaceholder: "例如 $5,000 / 1 柜",
        message: "关于您的项目(可选)",
      },
    },
    footer: {
      tagline: {
        en: "Planet Group Baku – Your direct link to China's best quality and prices.",
        az: "Planet Group Baku – Çinin ən yaxşı keyfiyyət və qiymətinə birbaşa bağlantınız.",
        ru: "Planet Group Baku – Ваша прямая связь с лучшим качеством и ценами Китая.",
      },
      address: "佛山 / 广州,中国  ·  巴库,阿塞拜疆",
      rights: "版权所有。",
      divisions: "部门",
      company: "公司",
      contact: "联系",
      emailLabel: "邮箱",
      emailIkelLabel: "五金 (İKEL MT)",
      phoneLabel: "电话 / WhatsApp",
      email: "planetgroupbaku@gmail.com",
      emailIkel: "kelmtfurniturehardware@gmail.com",
      phone: "+994 51 516 93 01",
      social: {
        title: "关注我们",
        instagram: "https://instagram.com/kel.mebel.aksesuarlari",
        instagramHandle: "@kel.mebel.aksesuarlari",
        tiktok: "https://tiktok.com/@kelmebelaksesuarlari",
        tiktokHandle: "@kelmebelaksesuarlari",
        linkedin: "https://linkedin.com/company/planet-group-baku",
        linkedinHandle: "Planet Group Baku",
      },
    },
  },
};

export const supportedLanguages = ["en", "az", "tr", "ru", "zh"];
